"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsedRowData = exports.googData = void 0;
exports.googData = {
    "range": "sampleData2!A1:X278",
    "majorDimension": "ROWS",
    "values": [
        [
            "Item",
            "Label",
            "Structure -->",
            "Groups",
            "Subgroup",
            "Options -->",
            "Description",
            "AllowedMin",
            "AllowedMax",
            "Unit",
            "SD",
            "Mean",
            "CV",
            "Status",
            "Analysis dates -->",
            "Presenting",
            "Date1",
            "Date2",
            "Date3",
            "Date4",
            "Date5",
            "Date6",
            "Date7",
            "Date8"
        ],
        [
            "QC-001",
            "",
            "",
            "QC-001",
            "QCSample",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Err-range",
            "1/1/2023 9:00:00; 2/1/2023 9:00:01; 3/1/2023 9:00:02; 4/1/2023 9:00:03; 5/1/2023 9:00:04; 6/1/2023 9:00:05; 7/1/2023 9:00:06; 8/1/2023 9:00:07",
            "11/16/2023 12:50:24",
            "1/1/2023 9:00:00",
            "2/1/2023 9:00:01",
            "3/1/2023 9:00:02",
            "4/1/2023 9:00:03",
            "5/1/2023 9:00:04",
            "6/1/2023 9:00:05",
            "7/1/2023 9:00:06",
            "8/1/2023 9:00:07"
        ],
        [
            "Material",
            "",
            "",
            "QC-001",
            "SampleInfo",
            "",
            "XN-L Control Level 1"
        ],
        [
            "Expiry Date",
            "",
            "",
            "QC-001",
            "SampleInfo",
            "",
            "31/08/2023"
        ],
        [
            "Cell Pack DCL",
            "",
            "",
            "QC-001",
            "ReagentInfo"
        ],
        [
            "Validated",
            "",
            "",
            "QC-001",
            "RunInfo"
        ],
        [
            "Output",
            "",
            "",
            "QC-001",
            "RunInfo"
        ],
        [
            "Rack no.",
            "Rack #",
            "",
            "QC-001",
            "RunInfo"
        ],
        [
            "Position",
            "",
            "",
            "QC-001",
            "RunInfo"
        ],
        [
            "Action",
            "",
            "",
            "QC-001",
            "RunInfo"
        ],
        [
            "Error",
            "",
            "",
            "QC-001",
            "RunInfo"
        ],
        [
            "P / N",
            "",
            "",
            "QC-001",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N"
        ],
        [
            "WBC",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "2.02",
            "2.73",
            "x 10^3/μL",
            "0.20",
            "2.38",
            "0.09",
            "",
            "",
            "2.31",
            "2.50",
            "2.59",
            "2.55",
            "2.09",
            "2.43",
            "2.08",
            "2.22",
            "2.23"
        ],
        [
            "RBC",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "2.17",
            "2.39",
            "x 10^6/μL",
            "0.10",
            "2.28",
            "0.04",
            "",
            "",
            "2.27",
            "2.00",
            "2.26",
            "2.25",
            "2.20",
            "2.22",
            "2.19",
            "2.34",
            "2.24"
        ],
        [
            "HCT",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "15.4",
            "17.7",
            "%",
            "0.56",
            "16.55",
            "0.03",
            "",
            "",
            "17.35",
            "17.57",
            "16.52",
            "16.01",
            "16.20",
            "16.78",
            "16.86",
            "16.55",
            "15.78"
        ],
        [
            "HGB",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "5.4",
            "5.9",
            "g/dL",
            "0.14",
            "5.65",
            "0.02",
            "",
            "",
            "5.62",
            "5.50",
            "5.68",
            "5.73",
            "5.81",
            "5.83",
            "5.74",
            "5.80",
            "5.46"
        ],
        [
            "MCV",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "75.6",
            "106.3",
            "fL",
            "7.55",
            "90.95",
            "0.08",
            "",
            "",
            "105.70",
            "96.87",
            "92.68",
            "81.90",
            "78.06",
            "92.51",
            "94.26",
            "96.62",
            "99.31"
        ],
        [
            "MCH",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "26.0",
            "36.4",
            "pg",
            "2.16",
            "31.20",
            "0.07",
            "",
            "",
            "30.75",
            "28.62",
            "30.63",
            "35.58",
            "31.59",
            "32.49",
            "33.56",
            "31.14",
            "30.13"
        ],
        [
            "MCHC",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "33.6",
            "35.7",
            "g/dL",
            "0.73",
            "34.65",
            "0.02",
            "",
            "",
            "34.62",
            "33.72",
            "33.63",
            "33.85",
            "33.68",
            "35.37",
            "35.08",
            "34.65",
            "35.04"
        ],
        [
            "PLT",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "95.0",
            "471.0",
            "x 10^3/μL",
            "68.05",
            "283.00",
            "0.24",
            "",
            "",
            "341.92",
            "290.08",
            "197.86",
            "181.16",
            "301.72",
            "274.01",
            "176.24",
            "154.10",
            "119.01"
        ],
        [
            "RDW-SD",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "34.9",
            "65.7",
            "fL",
            "6.54",
            "50.30",
            "0.13",
            "",
            "",
            "36.10",
            "48.84",
            "59.53",
            "43.97",
            "51.74",
            "41.82",
            "56.02",
            "41.83",
            "50.98"
        ],
        [
            "RDW-CV",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "13.3",
            "18.2",
            "%",
            "1.32",
            "15.75",
            "0.08",
            "",
            "",
            "15.79",
            "13.57",
            "14.71",
            "15.13",
            "15.62",
            "16.09",
            "17.00",
            "14.21",
            "17.36"
        ],
        [
            "MPV",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "7.3",
            "9.9",
            "fL",
            "0.72",
            "8.60",
            "0.08",
            "",
            "",
            "9.46",
            "8.71",
            "9.74",
            "7.91",
            "9.03",
            "9.70",
            "9.60",
            "8.21",
            "8.37"
        ],
        [
            "NEUT no.",
            "NEUT#",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "2.2",
            "11.4",
            "x 10^3/μL",
            "3.33",
            "6.80",
            "0.49",
            "",
            "",
            "9.60",
            "2.27",
            "8.21",
            "2.26",
            "3.55",
            "2.36",
            "11.14",
            "2.78",
            "5.86"
        ],
        [
            "LYMPH no.",
            "LYMPH #",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "1.2",
            "5.7",
            "x 10^3/μL",
            "1.57",
            "3.45",
            "0.45",
            "",
            "",
            "3.59",
            "1.48",
            "3.14",
            "5.43",
            "4.92",
            "1.41",
            "2.32",
            "3.14",
            "4.74"
        ],
        [
            "MONO no.",
            "MONO #",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "0.1",
            "5.0",
            "x 10^3/μL",
            "1.23",
            "2.55",
            "0.48",
            "",
            "",
            "0.29",
            "1.18",
            "1.22",
            "0.63",
            "2.83",
            "2.13",
            "1.61",
            "3.17",
            "4.30"
        ],
        [
            "EO no.",
            "EO #",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.5",
            "x 10^3/μL",
            "0.18",
            "0.25",
            "0.70",
            "",
            "",
            "0.08",
            "0.04",
            "0.49",
            "0.31",
            "0.15",
            "0.04",
            "0.02",
            "0.33",
            "0.06"
        ],
        [
            "BASO no.",
            "BASO #",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.1",
            "x 10^3/μL",
            "0.04",
            "0.05",
            "0.71",
            "",
            "",
            "0.09",
            "0.09",
            "0.06",
            "0.01",
            "0.00",
            "0.03",
            "0.06",
            "0.02",
            "0.10"
        ],
        [
            "NEUTpercent",
            "NEUT%",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "14.6",
            "69.3",
            "%",
            "10.65",
            "41.95",
            "0.25",
            "",
            "",
            "67.14",
            "49.53",
            "59.76",
            "43.49",
            "54.12",
            "25.95",
            "48.41",
            "35.86",
            "49.10"
        ],
        [
            "LYMPH percent",
            "LYMPH %",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "8.0",
            "70.0",
            "%",
            "21.92",
            "39.00",
            "0.56",
            "",
            "",
            "68.06",
            "62.95",
            "23.43",
            "69.22",
            "19.11",
            "24.22",
            "11.97",
            "31.93",
            "14.14"
        ],
        [
            "MONO percent",
            "MONO %",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "4.0",
            "19.0",
            "%",
            "2.66",
            "11.50",
            "0.23",
            "",
            "",
            "11.84",
            "13.76",
            "8.17",
            "10.09",
            "14.21",
            "15.48",
            "12.84",
            "9.04",
            "10.52"
        ],
        [
            "EO percent",
            "EO %",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "1.0",
            "7.0",
            "%",
            "2.06",
            "4.00",
            "0.51",
            "",
            "",
            "4.37",
            "3.43",
            "4.11",
            "2.65",
            "1.18",
            "2.26",
            "6.00",
            "6.80",
            "6.15"
        ],
        [
            "BASO percent",
            "BASO %",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.0",
            "%",
            "0.37",
            "0.50",
            "0.75",
            "",
            "",
            "0.42",
            "0.10",
            "0.84",
            "0.61",
            "0.84",
            "0.99",
            "0.87",
            "0.89",
            "0.03"
        ],
        [
            "IG no.",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.28",
            "x 10^3/μL%",
            "0.07",
            "0.14",
            "0.48",
            "",
            "",
            "0.16",
            "0.14",
            "0.04",
            "0.13",
            "0.17",
            "0.10",
            "0.10",
            "0.23",
            "0.23"
        ],
        [
            "IG percent",
            "IG %",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.7",
            "%",
            "0.44",
            "0.85",
            "0.52",
            "",
            "",
            "0.61",
            "0.25",
            "1.45",
            "0.85",
            "0.24",
            "0.33",
            "0.86",
            "0.48",
            "0.17"
        ],
        [
            "RET no.",
            "",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "29.0",
            "120.0",
            "x 10^6/μL",
            "15.13",
            "74.50",
            "0.20",
            "",
            "",
            "73.32",
            "74.85",
            "64.07",
            "65.74",
            "61.19",
            "87.36",
            "100.05",
            "92.74",
            "63.84"
        ],
        [
            "RET percent",
            "RET %",
            "",
            "QC-001",
            "HAParameter",
            "",
            "",
            "0.4",
            "4.8",
            "%",
            "1.38",
            "2.60",
            "0.53",
            "",
            "",
            "4.80",
            "3.37",
            "3.84",
            "3.00",
            "4.13",
            "0.81",
            "0.54",
            "2.44",
            "1.41"
        ],
        [
            "QC-002",
            "",
            "",
            "QC-002",
            "QCSample",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "OK",
            "8/1/2023 9:00:00; 9/9/2023 9:00:00; 9/15/2023 10:00:00",
            "11/16/2023 12:50:24",
            "8/1/2023 9:00:00",
            "9/9/2023 9:00:00",
            "9/15/2023 10:00:00"
        ],
        [
            "Material",
            "",
            "",
            "QC-002",
            "SampleInfo",
            "",
            "XN-L Control Level 2"
        ],
        [
            "Expiry Date",
            "",
            "",
            "QC-002",
            "SampleInfo",
            "",
            "31/08/2023"
        ],
        [
            "Cell Pack DCL",
            "",
            "",
            "QC-002",
            "ReagentInfo"
        ],
        [
            "Validated",
            "",
            "",
            "QC-002",
            "RunInfo"
        ],
        [
            "Output",
            "",
            "",
            "QC-002",
            "RunInfo"
        ],
        [
            "Rack no.",
            "Rack #",
            "",
            "QC-002",
            "RunInfo"
        ],
        [
            "Position",
            "",
            "",
            "QC-002",
            "RunInfo"
        ],
        [
            "Action",
            "",
            "",
            "QC-002",
            "RunInfo"
        ],
        [
            "Error",
            "",
            "",
            "QC-002",
            "RunInfo"
        ],
        [
            "P / N",
            "",
            "",
            "QC-002",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "N",
            "N",
            "N",
            "N"
        ],
        [
            "WBC",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "5.9",
            "16.7",
            "x 10^3/μL",
            "3.79",
            "11.30",
            "0.34",
            "",
            "",
            "7.00",
            "6.00",
            "7.00",
            "13.00"
        ],
        [
            "RBC",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "3.2",
            "5.1",
            "x 10^6/μL",
            "0.00",
            "4.16",
            "0.00",
            "",
            "",
            "4.00",
            "4.00",
            "4.00",
            "4.00"
        ],
        [
            "HGB",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "10.2",
            "16.6",
            "g/dL",
            "1.15",
            "13.40",
            "0.09",
            "",
            "",
            "11.00",
            "11.00",
            "11.00",
            "13.00"
        ],
        [
            "HCT",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "29.1",
            "47.7",
            "%",
            "4.04",
            "38.40",
            "0.11",
            "",
            "",
            "30.00",
            "30.00",
            "30.00",
            "37.00"
        ],
        [
            "MCV",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "75.6",
            "106.3",
            "fL",
            "10.15",
            "90.95",
            "0.11",
            "",
            "",
            "100.00",
            "80.00",
            "100.00",
            "87.00"
        ],
        [
            "MCH",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "26.0",
            "36.4",
            "pg",
            "1.73",
            "31.20",
            "0.06",
            "",
            "",
            "30.00",
            "30.00",
            "30.00",
            "33.00"
        ],
        [
            "MCHC",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "33.6",
            "35.7",
            "g/dL",
            "0.00",
            "34.65",
            "0.00",
            "",
            "",
            "35.00",
            "35.00",
            "35.00",
            "35.00"
        ],
        [
            "PLT",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "95.0",
            "471.0",
            "x 10^3/μL",
            "213.04",
            "283.00",
            "0.75",
            "",
            "",
            "115.00",
            "100.00",
            "100.00",
            "469.00"
        ],
        [
            "RDW-SD",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "34.9",
            "65.7",
            "fL",
            "1.15",
            "50.30",
            "0.02",
            "",
            "",
            "60.00",
            "60.00",
            "60.00",
            "58.00"
        ],
        [
            "RDW-CV",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "13.3",
            "18.2",
            "%",
            "0.58",
            "15.75",
            "0.04",
            "",
            "",
            "15.00",
            "15.00",
            "15.00",
            "16.00"
        ],
        [
            "MPV",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "7.3",
            "9.9",
            "fL",
            "0.00",
            "8.60",
            "0.00",
            "",
            "",
            "9.00",
            "9.00",
            "9.00",
            "9.00"
        ],
        [
            "NEUT no.",
            "NEUT#",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "2.2",
            "11.4",
            "x 10^3/μL",
            "1.00",
            "6.80",
            "0.15",
            "",
            "",
            "3.00",
            "5.00",
            "3.00",
            "4.00"
        ],
        [
            "LYMPH no.",
            "LYMPH #",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "1.2",
            "5.7",
            "x 10^3/μL",
            "0.58",
            "3.45",
            "0.17",
            "",
            "",
            "5.00",
            "5.00",
            "5.00",
            "4.00"
        ],
        [
            "MONO no.",
            "MONO #",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "0.1",
            "5.0",
            "x 10^3/μL",
            "2.31",
            "2.55",
            "0.91",
            "",
            "",
            "5.00",
            "5.00",
            "5.00",
            "1.00"
        ],
        [
            "EO no.",
            "EO #",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.5",
            "x 10^3/μL",
            "0.29",
            "0.25",
            "1.15",
            "",
            "",
            "0.50",
            "0.50",
            "0.50",
            "0.00"
        ],
        [
            "BASO no.",
            "BASO #",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.1",
            "x 10^3/μL",
            "0.06",
            "0.05",
            "1.15",
            "",
            "",
            "0.10",
            "0.10",
            "0.10",
            "0.00"
        ],
        [
            "NEUTpercent",
            "NEUT%",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "14.6",
            "69.3",
            "%",
            "29.44",
            "41.95",
            "0.70",
            "",
            "",
            "69.00",
            "69.00",
            "69.00",
            "18.00"
        ],
        [
            "LYMPH percent",
            "LYMPH %",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "8.0",
            "70.0",
            "%",
            "27.14",
            "39.00",
            "0.70",
            "",
            "",
            "70.00",
            "70.00",
            "70.00",
            "23.00"
        ],
        [
            "MONO percent",
            "MONO %",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "4.0",
            "19.0",
            "%",
            "2.31",
            "11.50",
            "0.20",
            "",
            "",
            "19.00",
            "19.00",
            "19.00",
            "15.00"
        ],
        [
            "EO percent",
            "EO %",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "1.0",
            "7.0",
            "%",
            "3.46",
            "4.00",
            "0.87",
            "",
            "",
            "7.00",
            "7.00",
            "7.00",
            "1.00"
        ],
        [
            "BASO percent",
            "BASO %",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.0",
            "%",
            "0.58",
            "0.50",
            "1.15",
            "",
            "",
            "1.00",
            "1.00",
            "1.00",
            "0.00"
        ],
        [
            "IG no.",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.28",
            "x 10^3/μL%",
            "0.12",
            "0.14",
            "0.82",
            "",
            "",
            "0.20",
            "0.20",
            "0.20",
            "0.00"
        ],
        [
            "IG percent",
            "IG %",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.7",
            "%",
            "0.00",
            "0.85",
            "0.00",
            "",
            "",
            "1.00",
            "1.00",
            "1.00",
            "1.00"
        ],
        [
            "RET no.",
            "",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "29.0",
            "120.0",
            "x 10^6/μL",
            "1.15",
            "74.50",
            "0.02",
            "",
            "",
            "100.00",
            "100.00",
            "100.00",
            "102.00"
        ],
        [
            "RET percent",
            "RET %",
            "",
            "QC-002",
            "HAParameter",
            "",
            "",
            "0.4",
            "4.8",
            "%",
            "1.73",
            "2.60",
            "0.67",
            "2.6",
            "",
            "1.00",
            "1.00",
            "1.00",
            "4.00"
        ],
        [
            "QC-003",
            "",
            "",
            "QC-003",
            "QCSample",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Err-range",
            "8/1/2023 9:00:00; 9/9/2023 9:00:00; 9/15/2023 10:00:00",
            "11/16/2023 12:50:24",
            "8/1/2023 9:00:00",
            "9/9/2023 9:00:00",
            "9/15/2023 10:00:00"
        ],
        [
            "Material",
            "",
            "",
            "QC-003",
            "SampleInfo",
            "",
            "XN-L Control Level 3"
        ],
        [
            "Expiry Date",
            "",
            "",
            "QC-003",
            "SampleInfo",
            "",
            "31/08/2023"
        ],
        [
            "Cell Pack DCL",
            "",
            "",
            "QC-003",
            "ReagentInfo"
        ],
        [
            "Validated",
            "",
            "",
            "QC-003",
            "RunInfo"
        ],
        [
            "Output",
            "",
            "",
            "QC-003",
            "RunInfo"
        ],
        [
            "Rack no.",
            "Rack #",
            "",
            "QC-003",
            "RunInfo"
        ],
        [
            "Position",
            "",
            "",
            "QC-003",
            "RunInfo"
        ],
        [
            "Action",
            "",
            "",
            "QC-003",
            "RunInfo"
        ],
        [
            "Error",
            "",
            "",
            "QC-003",
            "RunInfo"
        ],
        [
            "P / N",
            "",
            "",
            "QC-003",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "N",
            "N",
            "N",
            "N"
        ],
        [
            "WBC",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "5.9",
            "16.7",
            "x 10^3/μL",
            "5.69",
            "11.30",
            "0.50",
            "",
            "",
            "7.00",
            "6.00",
            "17.00",
            "14.00"
        ],
        [
            "RBC",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "3.2",
            "5.1",
            "x 10^6/μL",
            "0.58",
            "4.16",
            "0.14",
            "",
            "",
            "4.00",
            "4.00",
            "4.00",
            "5.00"
        ],
        [
            "HGB",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "10.2",
            "16.6",
            "g/dL",
            "1.15",
            "13.40",
            "0.09",
            "",
            "",
            "11.00",
            "11.00",
            "11.00",
            "13.00"
        ],
        [
            "HCT",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "29.1",
            "47.7",
            "%",
            "6.93",
            "38.40",
            "0.18",
            "",
            "",
            "30.00",
            "30.00",
            "30.00",
            "42.00"
        ],
        [
            "MCV",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "75.6",
            "106.3",
            "fL",
            "13.28",
            "90.95",
            "0.15",
            "",
            "",
            "100.00",
            "100.00",
            "100.00",
            "77.00"
        ],
        [
            "MCH",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "26.0",
            "36.4",
            "pg",
            "2.31",
            "31.20",
            "0.07",
            "",
            "",
            "30.00",
            "30.00",
            "30.00",
            "26.00"
        ],
        [
            "MCHC",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "33.6",
            "35.7",
            "g/dL",
            "2.31",
            "34.65",
            "0.07",
            "",
            "",
            "35.00",
            "35.00",
            "35.00",
            "31.00"
        ],
        [
            "PLT",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "95.0",
            "471.0",
            "x 10^3/μL",
            "107.39",
            "283.00",
            "0.38",
            "",
            "",
            "115.00",
            "100.00",
            "100.00",
            "286.00"
        ],
        [
            "RDW-SD",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "34.9",
            "65.7",
            "fL",
            "11.55",
            "50.30",
            "0.23",
            "",
            "",
            "60.00",
            "60.00",
            "60.00",
            "40.00"
        ],
        [
            "RDW-CV",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "13.3",
            "18.2",
            "%",
            "1.73",
            "15.75",
            "0.11",
            "",
            "",
            "15.00",
            "15.00",
            "15.00",
            "12.00"
        ],
        [
            "MPV",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "7.3",
            "9.9",
            "fL",
            "1.15",
            "8.60",
            "0.13",
            "",
            "",
            "9.00",
            "9.00",
            "9.00",
            "7.00"
        ],
        [
            "NEUT no.",
            "NEUT#",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "2.2",
            "11.4",
            "x 10^3/μL",
            "2.00",
            "6.80",
            "0.29",
            "",
            "",
            "3.00",
            "5.00",
            "3.00",
            "7.00"
        ],
        [
            "LYMPH no.",
            "LYMPH #",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "1.2",
            "5.7",
            "x 10^3/μL",
            "1.15",
            "3.45",
            "0.33",
            "",
            "",
            "5.00",
            "5.00",
            "5.00",
            "3.00"
        ],
        [
            "MONO no.",
            "MONO #",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "0.1",
            "5.0",
            "x 10^3/μL",
            "1.15",
            "2.55",
            "0.45",
            "",
            "",
            "5.00",
            "5.00",
            "5.00",
            "3.00"
        ],
        [
            "EO no.",
            "EO #",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.5",
            "x 10^3/μL",
            "0.29",
            "0.25",
            "1.15",
            "",
            "",
            "0.50",
            "0.50",
            "0.50",
            "0.00"
        ],
        [
            "BASO no.",
            "BASO #",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.1",
            "x 10^3/μL",
            "0.06",
            "0.05",
            "1.15",
            "",
            "",
            "0.10",
            "0.10",
            "0.10",
            "0.00"
        ],
        [
            "NEUTpercent",
            "NEUT%",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "14.6",
            "69.3",
            "%",
            "28.87",
            "41.95",
            "0.69",
            "",
            "",
            "69.00",
            "69.00",
            "69.00",
            "19.00"
        ],
        [
            "LYMPH percent",
            "LYMPH %",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "8.0",
            "70.0",
            "%",
            "31.75",
            "39.00",
            "0.81",
            "",
            "",
            "70.00",
            "70.00",
            "70.00",
            "15.00"
        ],
        [
            "MONO percent",
            "MONO %",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "4.0",
            "19.0",
            "%",
            "5.77",
            "11.50",
            "0.50",
            "",
            "",
            "19.00",
            "19.00",
            "19.00",
            "9.00"
        ],
        [
            "EO percent",
            "EO %",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "1.0",
            "7.0",
            "%",
            "1.15",
            "4.00",
            "0.29",
            "",
            "",
            "7.00",
            "7.00",
            "7.00",
            "5.00"
        ],
        [
            "BASO percent",
            "BASO %",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.0",
            "%",
            "0.58",
            "0.50",
            "1.15",
            "",
            "",
            "1.00",
            "1.00",
            "1.00",
            "0.00"
        ],
        [
            "IG no.",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.28",
            "x 10^3/μL%",
            "0.12",
            "0.14",
            "0.82",
            "",
            "",
            "0.20",
            "0.20",
            "0.20",
            "0.00"
        ],
        [
            "IG percent",
            "IG %",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.7",
            "%",
            "0.00",
            "0.85",
            "0.00",
            "",
            "",
            "1.00",
            "1.00",
            "1.00",
            "1.00"
        ],
        [
            "RET no.",
            "",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "29.0",
            "120.0",
            "x 10^6/μL",
            "25.40",
            "74.50",
            "0.34",
            "",
            "",
            "100.00",
            "100.00",
            "100.00",
            "56.00"
        ],
        [
            "RET percent",
            "RET %",
            "",
            "QC-003",
            "HAParameter",
            "",
            "",
            "0.4",
            "4.8",
            "%",
            "0.58",
            "2.60",
            "0.22",
            "",
            "",
            "1.00",
            "1.00",
            "1.00",
            "2.00"
        ],
        [
            "QC-004",
            "",
            "",
            "QC-004",
            "QCSample",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Err-range",
            "8/1/2023 9:00:00",
            "11/16/2023 12:50:24",
            "8/1/2023 9:00:00"
        ],
        [
            "Material",
            "",
            "",
            "QC-004",
            "SampleInfo",
            "",
            "XN-L Control Level 4"
        ],
        [
            "Expiry Date",
            "",
            "",
            "QC-004",
            "SampleInfo",
            "",
            "31/12/2023"
        ],
        [
            "Cell Pack DCL",
            "",
            "",
            "QC-004",
            "ReagentInfo"
        ],
        [
            "Validated",
            "",
            "",
            "QC-004",
            "RunInfo"
        ],
        [
            "Output",
            "",
            "",
            "QC-004",
            "RunInfo"
        ],
        [
            "Rack no.",
            "Rack #",
            "",
            "QC-004",
            "RunInfo"
        ],
        [
            "Position",
            "",
            "",
            "QC-004",
            "RunInfo"
        ],
        [
            "Action",
            "",
            "",
            "QC-004",
            "RunInfo"
        ],
        [
            "Error",
            "",
            "",
            "QC-004",
            "RunInfo"
        ],
        [
            "P / N",
            "",
            "",
            "QC-004",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "P",
            "P"
        ],
        [
            "WBC",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "5.9",
            "16.7",
            "x 10^3/μL",
            "0.00",
            "11.30",
            "0.00",
            "",
            "",
            "",
            "5.00",
            "5.00"
        ],
        [
            "RBC",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "3.2",
            "5.1",
            "x 10^6/μL",
            "0.00",
            "4.16",
            "0.00",
            "",
            "",
            "",
            "4.00",
            "4.00"
        ],
        [
            "HGB",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "10.2",
            "16.6",
            "g/dL",
            "0.00",
            "13.40",
            "0.00",
            "",
            "",
            "",
            "11.00",
            "11.00"
        ],
        [
            "HCT",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "29.1",
            "47.7",
            "%",
            "0.00",
            "38.40",
            "0.00",
            "",
            "",
            "",
            "30.00",
            "30.00"
        ],
        [
            "MCV",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "75.6",
            "106.3",
            "fL",
            "0.00",
            "90.95",
            "0.00",
            "",
            "",
            "",
            "100.00",
            "100.00"
        ],
        [
            "MCH",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "26.0",
            "36.4",
            "pg",
            "0.00",
            "31.20",
            "0.00",
            "",
            "",
            "",
            "30.00",
            "30.00"
        ],
        [
            "MCHC",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "33.6",
            "35.7",
            "g/dL",
            "0.00",
            "34.65",
            "0.00",
            "",
            "",
            "",
            "35.00",
            "35.00"
        ],
        [
            "PLT",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "95.0",
            "471.0",
            "x 10^3/μL",
            "0.00",
            "283.00",
            "0.00",
            "",
            "",
            "",
            "100.00",
            "100.00"
        ],
        [
            "RDW-SD",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "34.9",
            "65.7",
            "fL",
            "0.00",
            "50.30",
            "0.00",
            "",
            "",
            "",
            "60.00",
            "60.00"
        ],
        [
            "RDW-CV",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "13.3",
            "18.2",
            "%",
            "0.00",
            "15.75",
            "0.00",
            "",
            "",
            "",
            "15.00",
            "15.00"
        ],
        [
            "MPV",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "7.3",
            "9.9",
            "fL",
            "0.00",
            "8.60",
            "0.00",
            "",
            "",
            "",
            "9.00",
            "9.00"
        ],
        [
            "NEUT no.",
            "NEUT#",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "2.2",
            "11.4",
            "x 10^3/μL",
            "0.00",
            "6.80",
            "0.00",
            "",
            "",
            "",
            "5.00",
            "5.00"
        ],
        [
            "LYMPH no.",
            "LYMPH #",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "1.2",
            "5.7",
            "x 10^3/μL",
            "0.00",
            "3.45",
            "0.00",
            "",
            "",
            "",
            "5.00",
            "5.00"
        ],
        [
            "MONO no.",
            "MONO #",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "0.1",
            "5.0",
            "x 10^3/μL",
            "0.00",
            "2.55",
            "0.00",
            "",
            "",
            "",
            "5.00",
            "5.00"
        ],
        [
            "EO no.",
            "EO #",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.5",
            "x 10^3/μL",
            "0.00",
            "0.25",
            "0.00",
            "",
            "",
            "",
            "0.50",
            "0.50"
        ],
        [
            "BASO no.",
            "BASO #",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.1",
            "x 10^3/μL",
            "0.00",
            "0.05",
            "0.00",
            "",
            "",
            "",
            "0.10",
            "0.10"
        ],
        [
            "NEUTpercent",
            "NEUT%",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "14.6",
            "69.3",
            "%",
            "0.00",
            "41.95",
            "0.00",
            "",
            "",
            "",
            "69.00",
            "69.00"
        ],
        [
            "LYMPH percent",
            "LYMPH %",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "8.0",
            "70.0",
            "%",
            "0.00",
            "39.00",
            "0.00",
            "",
            "",
            "",
            "70.00",
            "70.00"
        ],
        [
            "MONO percent",
            "MONO %",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "4.0",
            "19.0",
            "%",
            "0.00",
            "11.50",
            "0.00",
            "",
            "",
            "",
            "19.00",
            "19.00"
        ],
        [
            "EO percent",
            "EO %",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "1.0",
            "7.0",
            "%",
            "0.00",
            "4.00",
            "0.00",
            "",
            "",
            "",
            "7.00",
            "7.00"
        ],
        [
            "BASO percent",
            "BASO %",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.0",
            "%",
            "0.00",
            "0.50",
            "0.00",
            "",
            "",
            "",
            "1.00",
            "1.00"
        ],
        [
            "IG no.",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.28",
            "x 10^3/μL%",
            "0.00",
            "0.14",
            "0.00",
            "",
            "",
            "",
            "0.20",
            "0.20"
        ],
        [
            "IG percent",
            "IG %",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.7",
            "%",
            "0.00",
            "0.85",
            "0.00",
            "",
            "",
            "",
            "1.00",
            "1.00"
        ],
        [
            "RET no.",
            "",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "29.0",
            "120.0",
            "x 10^6/μL",
            "0.00",
            "74.50",
            "0.00",
            "",
            "",
            "",
            "100.00",
            "100.00"
        ],
        [
            "RET percent",
            "RET %",
            "",
            "QC-004",
            "HAParameter",
            "",
            "",
            "0.4",
            "4.8",
            "%",
            "0.00",
            "2.60",
            "0.00",
            "",
            "",
            "",
            "1.00",
            "1.00"
        ],
        [],
        [
            "P12345",
            "",
            "",
            "P12345",
            "MASample",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Err-range",
            "8/1/2023 11:27:55; 9/1/2023 1:27:56; 10/1/2023 11:27:56",
            "11/16/2023 12:50:24",
            "8/1/2023 11:27:55",
            "9/1/2023 1:27:56",
            "10/1/2023 11:27:56"
        ],
        [
            "MRN",
            "",
            "",
            "P12345",
            "PatientInfo",
            "",
            "112233"
        ],
        [
            "First Name",
            "",
            "",
            "P12345",
            "PatientInfo",
            "",
            "Jon"
        ],
        [
            "Last Name",
            "",
            "",
            "P12345",
            "PatientInfo",
            "",
            "Doe"
        ],
        [
            "Gender",
            "",
            "",
            "P12345",
            "PatientInfo",
            "",
            "M"
        ],
        [
            "age",
            "",
            "",
            "P12345",
            "PatientInfo",
            "",
            "50"
        ],
        [
            "ward",
            "",
            "",
            "P12345",
            "PatientInfo",
            "",
            "7"
        ],
        [
            "doctor",
            "",
            "",
            "P12345",
            "PatientInfo",
            "",
            "M.D"
        ],
        [
            "Cell Pack DCL",
            "",
            "",
            "P12345",
            "ReagentInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Y3006",
            "Y3007",
            "Y3008",
            "Y3009"
        ],
        [
            "Sulfoyser",
            "",
            "",
            "P12345",
            "ReagentInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "A2014",
            "A2015",
            "A2016",
            "A2017"
        ],
        [
            "Lysercell WDF",
            "",
            "",
            "P12345",
            "ReagentInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Y2061",
            "Y2062",
            "Y2063",
            "Y2064"
        ],
        [
            "Validated",
            "",
            "",
            "P12345",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "V",
            "V"
        ],
        [
            "Output",
            "",
            "",
            "P12345",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "GH",
            "G"
        ],
        [
            "Rack no.",
            "Rack #",
            "",
            "P12345",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "2"
        ],
        [
            "Position",
            "",
            "",
            "P12345",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1"
        ],
        [
            "Action",
            "",
            "",
            "P12345",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "recommend another method"
        ],
        [
            "Error",
            "",
            "",
            "P12345",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "an error"
        ],
        [
            "P / N",
            "",
            "",
            "P12345",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "N",
            "N",
            "N",
            "P"
        ],
        [
            "Flags",
            "",
            "",
            "P12345",
            "Other",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "WBC Abn Scg, \nBl/Abn Ly? (250),\nAniso\nHypochromia\n"
        ],
        [
            "Graph",
            "",
            "",
            "P12345",
            "Other",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "https://healthcare-in-europe.com/media/story_section_image/2556/image-01-beck2.jpg"
        ],
        [
            "WBC",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "5.9",
            "16.7",
            "x 10^3/μL",
            "5.45",
            "11.30",
            "0.48",
            "",
            "",
            "6.87",
            "5.9",
            "16.7",
            "10.00"
        ],
        [
            "RBC",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "3.2",
            "5.1",
            "x 10^6/μL",
            "0.92",
            "4.16",
            "0.22",
            "",
            "",
            "4.46",
            "3.2",
            "5.1",
            "4.00"
        ],
        [
            "HGB",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "10.2",
            "16.6",
            "g/dL",
            "3.49",
            "13.40",
            "0.26",
            "",
            "",
            "9.5",
            "10.2",
            "16.6",
            "11.00"
        ],
        [
            "HCT",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.0",
            "L/L",
            "18.77",
            "0.50",
            "37.54",
            "",
            "",
            "0.292",
            "0.0",
            "1.0",
            "33.00"
        ],
        [
            "MCV",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "75.6",
            "106.3",
            "fL",
            "15.36",
            "90.95",
            "0.17",
            "",
            "",
            "78",
            "75.6",
            "106.3",
            "92.00"
        ],
        [
            "MCH",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "26.0",
            "36.4",
            "pg",
            "5.35",
            "31.20",
            "0.17",
            "",
            "",
            "26",
            "26.0",
            "36.4",
            "29.00"
        ],
        [
            "MCHC",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "33.6",
            "35.7",
            "g/dL",
            "1.12",
            "34.65",
            "0.03",
            "",
            "",
            "34",
            "33.6",
            "35.7",
            "34.00"
        ],
        [
            "PLT",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "95.0",
            "471.0",
            "x 10^3/μL",
            "206.99",
            "283.00",
            "0.73",
            "",
            "",
            "211",
            "95.0",
            "471.0",
            "433.00"
        ],
        [
            "RDW-SD",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "34.9",
            "65.7",
            "fL",
            "17.58",
            "50.30",
            "0.35",
            "",
            "",
            "46.2",
            "34.9",
            "65.7",
            "65.00"
        ],
        [
            "RDW-CV",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "13.3",
            "18.2",
            "%",
            "2.65",
            "15.75",
            "0.17",
            "",
            "",
            "14",
            "13.3",
            "18.2",
            "14.00"
        ],
        [
            "MPV",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "7.3",
            "9.9",
            "fL",
            "1.32",
            "8.60",
            "0.15",
            "",
            "",
            "8",
            "7.3",
            "9.9",
            "9.00"
        ],
        [
            "NEUT no.",
            "NEUT#",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "2.2",
            "11.4",
            "x 10^3/μL",
            "4.77",
            "6.80",
            "0.70",
            "",
            "",
            "4.33",
            "2.2",
            "11.4",
            "9.00"
        ],
        [
            "LYMPH no.",
            "LYMPH #",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "1.2",
            "5.7",
            "x 10^3/μL",
            "2.27",
            "3.45",
            "0.66",
            "",
            "",
            "1.32",
            "1.2",
            "5.7",
            "4.00"
        ],
        [
            "MONO no.",
            "MONO #",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "0.1",
            "5.0",
            "x 10^3/μL",
            "2.46",
            "2.55",
            "0.97",
            "",
            "",
            "0.91",
            "0.1",
            "5.0",
            "3.00"
        ],
        [
            "EO no.",
            "EO #",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.5",
            "x 10^3/μL",
            "0.29",
            "0.25",
            "1.15",
            "",
            "",
            "0.28",
            "0.0",
            "0.5",
            "0.00"
        ],
        [
            "BASO no.",
            "BASO #",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.1",
            "x 10^3/μL",
            "0.06",
            "0.05",
            "1.15",
            "",
            "",
            "0.03",
            "0.0",
            "0.1",
            "0.00"
        ],
        [
            "NEUT percent",
            "NEUT%",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "14.6",
            "69.3",
            "%",
            "29.48",
            "41.95",
            "0.70",
            "",
            "",
            "63.1",
            "14.6",
            "69.3",
            "61.00"
        ],
        [
            "LYMPH percent",
            "LYMPH %",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "8.0",
            "70.0",
            "%",
            "32.52",
            "39.00",
            "0.83",
            "",
            "",
            "19.2",
            "8.0",
            "70.0",
            "56.00"
        ],
        [
            "MONO percent",
            "MONO %",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "4.0",
            "19.0",
            "%",
            "7.51",
            "11.50",
            "0.65",
            "",
            "",
            "13.2",
            "4.0",
            "19.0",
            "12.00"
        ],
        [
            "EO percent",
            "EO %",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "1.0",
            "7.0",
            "%",
            "3.21",
            "4.00",
            "0.80",
            "",
            "",
            "4.1",
            "1.0",
            "7.0",
            "2.00"
        ],
        [
            "BASO percent",
            "BASO %",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.0",
            "%",
            "0.58",
            "0.50",
            "1.15",
            "",
            "",
            "0.4",
            "0.0",
            "1.0",
            "0.00"
        ],
        [
            "IG no.",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.28",
            "x 10^9/L%",
            "0.16",
            "0.14",
            "1.15",
            "",
            "",
            "0.07",
            "0.0",
            "0.28",
            "0.00"
        ],
        [
            "IG percent",
            "IG %",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.7",
            "%",
            "0.98",
            "0.85",
            "1.15",
            "",
            "",
            "1.6",
            "0.0",
            "1.7",
            "0.00"
        ],
        [
            "RET no.",
            "",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "29.0",
            "120.0",
            "x 10^6/μL",
            "45.98",
            "74.50",
            "0.62",
            "",
            "",
            "100",
            "29.0",
            "120.0",
            "63.00"
        ],
        [
            "RET percent",
            "RET %",
            "",
            "P12345",
            "HAParameter",
            "",
            "",
            "0.4",
            "4.8",
            "%",
            "2.34",
            "2.60",
            "0.90",
            "",
            "",
            "1.01",
            "0.4",
            "4.8",
            "4.00"
        ],
        [
            "P11111",
            "",
            "",
            "P11111",
            "PASample",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Err-range",
            "",
            "11/16/2023 12:50:24"
        ],
        [
            "MRN",
            "",
            "",
            "P11111",
            "PatientInfo",
            "",
            "011-11"
        ],
        [
            "First Name",
            "",
            "",
            "P11111",
            "PatientInfo",
            "",
            "One"
        ],
        [
            "Last Name",
            "",
            "",
            "P11111",
            "PatientInfo",
            "",
            "Patient"
        ],
        [
            "Gender",
            "",
            "",
            "P11111",
            "PatientInfo",
            "",
            "F"
        ],
        [
            "age",
            "",
            "",
            "P11111",
            "PatientInfo",
            "",
            "25"
        ],
        [
            "ward",
            "",
            "",
            "P11111",
            "PatientInfo",
            "",
            "7"
        ],
        [
            "doctor",
            "",
            "",
            "P11111",
            "PatientInfo",
            "",
            "M.D"
        ],
        [
            "Cell Pack DCL",
            "",
            "",
            "P11111",
            "ReagentInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Y3006"
        ],
        [
            "Sulfoyser",
            "",
            "",
            "P11111",
            "ReagentInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "A2014"
        ],
        [
            "Lysercell WDF",
            "",
            "",
            "P11111",
            "ReagentInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Y2061"
        ],
        [
            "Validated",
            "",
            "",
            "P11111",
            "RunInfo"
        ],
        [
            "Output",
            "",
            "",
            "P11111",
            "RunInfo"
        ],
        [
            "Rack no.",
            "Rack #",
            "",
            "P11111",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1"
        ],
        [
            "Position",
            "",
            "",
            "P11111",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1"
        ],
        [
            "Action",
            "",
            "",
            "P11111",
            "RunInfo"
        ],
        [
            "Error",
            "",
            "",
            "P11111",
            "RunInfo"
        ],
        [
            "P / N",
            "",
            "",
            "P11111",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "N"
        ],
        [
            "Flags",
            "",
            "",
            "P11111",
            "Other"
        ],
        [
            "Graph",
            "",
            "",
            "P11111",
            "Other"
        ],
        [
            "WBC",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "5.9",
            "16.7",
            "x 10^3/μL",
            "0",
            "11.30",
            "0.00",
            "",
            "",
            "6.87"
        ],
        [
            "RBC",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "3.2",
            "5.1",
            "x 10^6/μL",
            "0",
            "4.16",
            "0.00",
            "",
            "",
            "4.46"
        ],
        [
            "HGB",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "10.2",
            "16.6",
            "g/dL",
            "0",
            "13.40",
            "0.00",
            "",
            "",
            "9.5"
        ],
        [
            "HCT",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.0",
            "L/L",
            "0",
            "0.50",
            "0.00",
            "",
            "",
            "0.292"
        ],
        [
            "MCV",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "75.6",
            "106.3",
            "fL",
            "0",
            "90.95",
            "0.00",
            "",
            "",
            "78"
        ],
        [
            "MCH",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "26.0",
            "36.4",
            "pg",
            "0",
            "31.20",
            "0.00",
            "",
            "",
            "26"
        ],
        [
            "MCHC",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "33.6",
            "35.7",
            "g/dL",
            "0",
            "34.65",
            "0.00",
            "",
            "",
            "34"
        ],
        [
            "PLT",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "95.0",
            "471.0",
            "x 10^3/μL",
            "0",
            "283.00",
            "0.00",
            "",
            "",
            "211"
        ],
        [
            "RDW-SD",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "34.9",
            "65.7",
            "fL",
            "0",
            "50.30",
            "0.00",
            "",
            "",
            "46.2"
        ],
        [
            "RDW-CV",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "13.3",
            "18.2",
            "%",
            "0",
            "15.75",
            "0.00",
            "",
            "",
            "14"
        ],
        [
            "MPV",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "7.3",
            "9.9",
            "fL",
            "0",
            "8.60",
            "0.00",
            "",
            "",
            "8"
        ],
        [
            "NEUT no.",
            "NEUT#",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "2.2",
            "11.4",
            "x 10^3/μL",
            "0",
            "6.80",
            "0.00",
            "",
            "",
            "4.33"
        ],
        [
            "LYMPH no.",
            "LYMPH #",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "1.2",
            "5.7",
            "x 10^3/μL",
            "0",
            "3.45",
            "0.00",
            "",
            "",
            "1.32"
        ],
        [
            "MONO no.",
            "MONO #",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "0.1",
            "5.0",
            "x 10^3/μL",
            "0",
            "2.55",
            "0.00",
            "",
            "",
            "0.91"
        ],
        [
            "EO no.",
            "EO #",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.5",
            "x 10^3/μL",
            "0",
            "0.25",
            "0.00",
            "",
            "",
            "0.28"
        ],
        [
            "BASO no.",
            "BASO #",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.1",
            "x 10^3/μL",
            "0",
            "0.05",
            "0.00",
            "",
            "",
            "0.03"
        ],
        [
            "NEUT percent",
            "NEUT%",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "14.6",
            "69.3",
            "%",
            "0",
            "41.95",
            "0.00",
            "",
            "",
            "63.1"
        ],
        [
            "LYMPH percent",
            "LYMPH %",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "8.0",
            "70.0",
            "%",
            "0",
            "39.00",
            "0.00",
            "",
            "",
            "19.2"
        ],
        [
            "MONO percent",
            "MONO %",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "4.0",
            "19.0",
            "%",
            "0",
            "11.50",
            "0.00",
            "",
            "",
            "13.2"
        ],
        [
            "EO percent",
            "EO %",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "1.0",
            "7.0",
            "%",
            "0",
            "4.00",
            "0.00",
            "",
            "",
            "4.1"
        ],
        [
            "BASO percent",
            "BASO %",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.0",
            "%",
            "0",
            "0.50",
            "0.00",
            "",
            "",
            "0.4"
        ],
        [
            "IG no.",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.28",
            "x 10^9/L%",
            "0",
            "0.14",
            "0.00",
            "",
            "",
            "0.07"
        ],
        [
            "IG percent",
            "IG %",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.7",
            "%",
            "0",
            "0.85",
            "0.00",
            "",
            "",
            "1.6"
        ],
        [
            "RET no.",
            "",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "29.0",
            "120.0",
            "x 10^6/μL",
            "0",
            "74.50",
            "0.00",
            "",
            "",
            "100"
        ],
        [
            "RET percent",
            "RET %",
            "",
            "P11111",
            "HAParameter",
            "",
            "",
            "0.4",
            "4.8",
            "%",
            "0",
            "2.60",
            "0.00",
            "",
            "",
            "1.01"
        ],
        [
            "P22222",
            "",
            "",
            "P22222",
            "PASample",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Err-range",
            "",
            "11/16/2023 12:50:24"
        ],
        [
            "MRN",
            "",
            "",
            "P22222",
            "PatientInfo",
            "",
            "011-22"
        ],
        [
            "First Name",
            "",
            "",
            "P22222",
            "PatientInfo",
            "",
            "Two"
        ],
        [
            "Last Name",
            "",
            "",
            "P22222",
            "PatientInfo",
            "",
            "Patient"
        ],
        [
            "Gender",
            "",
            "",
            "P22222",
            "PatientInfo",
            "",
            "F"
        ],
        [
            "age",
            "",
            "",
            "P22222",
            "PatientInfo",
            "",
            "25"
        ],
        [
            "ward",
            "",
            "",
            "P22222",
            "PatientInfo",
            "",
            "7"
        ],
        [
            "doctor",
            "",
            "",
            "P22222",
            "PatientInfo",
            "",
            "M.D"
        ],
        [
            "Cell Pack DCL",
            "",
            "",
            "P22222",
            "ReagentInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Y3006"
        ],
        [
            "Sulfoyser",
            "",
            "",
            "P22222",
            "ReagentInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "A2014"
        ],
        [
            "Lysercell WDF",
            "",
            "",
            "P22222",
            "ReagentInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Y2061"
        ],
        [
            "Validated",
            "",
            "",
            "P22222",
            "RunInfo"
        ],
        [
            "Output",
            "",
            "",
            "P22222",
            "RunInfo"
        ],
        [
            "Rack no.",
            "Rack #",
            "",
            "P22222",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1"
        ],
        [
            "Position",
            "",
            "",
            "P22222",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "1"
        ],
        [
            "Action",
            "",
            "",
            "P22222",
            "RunInfo"
        ],
        [
            "Error",
            "",
            "",
            "P22222",
            "RunInfo"
        ],
        [
            "P / N",
            "",
            "",
            "P22222",
            "RunInfo",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "N"
        ],
        [
            "Flags",
            "",
            "",
            "P22222",
            "Other"
        ],
        [
            "Graph",
            "",
            "",
            "P22222",
            "Other"
        ],
        [
            "WBC",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "5.9",
            "16.7",
            "x 10^3/μL",
            "0",
            "11.30",
            "0.00",
            "",
            "",
            "6.87"
        ],
        [
            "RBC",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "3.2",
            "5.1",
            "x 10^6/μL",
            "0",
            "4.16",
            "0.00",
            "",
            "",
            "4.46"
        ],
        [
            "HGB",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "10.2",
            "16.6",
            "g/dL",
            "0",
            "13.40",
            "0.00",
            "",
            "",
            "9.5"
        ],
        [
            "HCT",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.0",
            "L/L",
            "0",
            "0.50",
            "0.00",
            "",
            "",
            "0.292"
        ],
        [
            "MCV",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "75.6",
            "106.3",
            "fL",
            "0",
            "90.95",
            "0.00",
            "",
            "",
            "78"
        ],
        [
            "MCH",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "26.0",
            "36.4",
            "pg",
            "0",
            "31.20",
            "0.00",
            "",
            "",
            "26"
        ],
        [
            "MCHC",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "33.6",
            "35.7",
            "g/dL",
            "0",
            "34.65",
            "0.00",
            "",
            "",
            "34"
        ],
        [
            "PLT",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "95.0",
            "471.0",
            "x 10^3/μL",
            "0",
            "283.00",
            "0.00",
            "",
            "",
            "211"
        ],
        [
            "RDW-SD",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "34.9",
            "65.7",
            "fL",
            "0",
            "50.30",
            "0.00",
            "",
            "",
            "46.2"
        ],
        [
            "RDW-CV",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "13.3",
            "18.2",
            "%",
            "0",
            "15.75",
            "0.00",
            "",
            "",
            "14"
        ],
        [
            "MPV",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "7.3",
            "9.9",
            "fL",
            "0",
            "8.60",
            "0.00",
            "",
            "",
            "8"
        ],
        [
            "NEUT no.",
            "NEUT#",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "2.2",
            "11.4",
            "x 10^3/μL",
            "0",
            "6.80",
            "0.00",
            "",
            "",
            "4.33"
        ],
        [
            "LYMPH no.",
            "LYMPH #",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "1.2",
            "5.7",
            "x 10^3/μL",
            "0",
            "3.45",
            "0.00",
            "",
            "",
            "1.32"
        ],
        [
            "MONO no.",
            "MONO #",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "0.1",
            "5.0",
            "x 10^3/μL",
            "0",
            "2.55",
            "0.00",
            "",
            "",
            "0.91"
        ],
        [
            "EO no.",
            "EO #",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.5",
            "x 10^3/μL",
            "0",
            "0.25",
            "0.00",
            "",
            "",
            "0.28"
        ],
        [
            "BASO no.",
            "BASO #",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.1",
            "x 10^3/μL",
            "0",
            "0.05",
            "0.00",
            "",
            "",
            "0.03"
        ],
        [
            "NEUT percent",
            "NEUT%",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "14.6",
            "69.3",
            "%",
            "0",
            "41.95",
            "0.00",
            "",
            "",
            "63.1"
        ],
        [
            "LYMPH percent",
            "LYMPH %",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "8.0",
            "70.0",
            "%",
            "0",
            "39.00",
            "0.00",
            "",
            "",
            "19.2"
        ],
        [
            "MONO percent",
            "MONO %",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "4.0",
            "19.0",
            "%",
            "0",
            "11.50",
            "0.00",
            "",
            "",
            "13.2"
        ],
        [
            "EO percent",
            "EO %",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "1.0",
            "7.0",
            "%",
            "0",
            "4.00",
            "0.00",
            "",
            "",
            "4.1"
        ],
        [
            "BASO percent",
            "BASO %",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.0",
            "%",
            "0",
            "0.50",
            "0.00",
            "",
            "",
            "0.4"
        ],
        [
            "IG no.",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "0.0",
            "0.28",
            "x 10^9/L%",
            "0",
            "0.14",
            "0.00",
            "",
            "",
            "0.07"
        ],
        [
            "IG percent",
            "IG %",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "0.0",
            "1.7",
            "%",
            "0",
            "0.85",
            "0.00",
            "",
            "",
            "1.6"
        ],
        [
            "RET no.",
            "",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "29.0",
            "120.0",
            "x 10^6/μL",
            "0",
            "74.50",
            "0.00",
            "",
            "",
            "100"
        ],
        [
            "RET percent",
            "RET %",
            "",
            "P22222",
            "HAParameter",
            "",
            "",
            "0.4",
            "4.8",
            "%",
            "0",
            "2.60",
            "0.00",
            "",
            "",
            "1.01"
        ]
    ]
};
exports.parsedRowData = [
    {
        "Item": "QC-001",
        "Label": "",
        "Structure -->": "",
        "Groups": "QCSample",
        "Subgroup": "QCSample",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "Err-range",
        "Analysis dates -->": "1/1/2023 9:00:00; 2/1/2023 9:00:01; 3/1/2023 9:00:02; 4/1/2023 9:00:03; 5/1/2023 9:00:04; 6/1/2023 9:00:05; 7/1/2023 9:00:06; 8/1/2023 9:00:07",
        "Presenting": "11/16/2023 12:50:24",
        "Date1": "1/1/2023 9:00:00",
        "Date2": "2/1/2023 9:00:01",
        "Date3": "3/1/2023 9:00:02",
        "Date4": "4/1/2023 9:00:03",
        "Date5": "5/1/2023 9:00:04",
        "Date6": "6/1/2023 9:00:05",
        "Date7": "7/1/2023 9:00:06",
        "Date8": "8/1/2023 9:00:07"
    },
    {
        "Item": "Material",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "SampleInfo",
        "Options -->": "",
        "Description": "XN-L Control Level 1"
    },
    {
        "Item": "Expiry Date",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "SampleInfo",
        "Options -->": "",
        "Description": "31/08/2023"
    },
    {
        "Item": "Cell Pack DCL",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "ReagentInfo"
    },
    {
        "Item": "Validated",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Output",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Rack no.",
        "Label": "Rack #",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Position",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Action",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Error",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "P / N",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "N",
        "Date1": "N",
        "Date2": "N",
        "Date3": "N",
        "Date4": "N",
        "Date5": "N",
        "Date6": "N",
        "Date7": "N",
        "Date8": "N"
    },
    {
        "Item": "WBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "2.02",
        "AllowedMax": "2.73",
        "Unit": "x 10^3/μL",
        "SD": "0.20",
        "Mean": "2.38",
        "CV": "0.09",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "2.31",
        "Date1": "2.50",
        "Date2": "2.59",
        "Date3": "2.55",
        "Date4": "2.09",
        "Date5": "2.43",
        "Date6": "2.08",
        "Date7": "2.22",
        "Date8": "2.23"
    },
    {
        "Item": "RBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "2.17",
        "AllowedMax": "2.39",
        "Unit": "x 10^6/μL",
        "SD": "0.10",
        "Mean": "2.28",
        "CV": "0.04",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "2.27",
        "Date1": "2.00",
        "Date2": "2.26",
        "Date3": "2.25",
        "Date4": "2.20",
        "Date5": "2.22",
        "Date6": "2.19",
        "Date7": "2.34",
        "Date8": "2.24"
    },
    {
        "Item": "HCT",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "15.4",
        "AllowedMax": "17.7",
        "Unit": "%",
        "SD": "0.56",
        "Mean": "16.55",
        "CV": "0.03",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "17.35",
        "Date1": "17.57",
        "Date2": "16.52",
        "Date3": "16.01",
        "Date4": "16.20",
        "Date5": "16.78",
        "Date6": "16.86",
        "Date7": "16.55",
        "Date8": "15.78"
    },
    {
        "Item": "HGB",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "5.4",
        "AllowedMax": "5.9",
        "Unit": "g/dL",
        "SD": "0.14",
        "Mean": "5.65",
        "CV": "0.02",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "5.62",
        "Date1": "5.50",
        "Date2": "5.68",
        "Date3": "5.73",
        "Date4": "5.81",
        "Date5": "5.83",
        "Date6": "5.74",
        "Date7": "5.80",
        "Date8": "5.46"
    },
    {
        "Item": "MCV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "75.6",
        "AllowedMax": "106.3",
        "Unit": "fL",
        "SD": "7.55",
        "Mean": "90.95",
        "CV": "0.08",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "105.70",
        "Date1": "96.87",
        "Date2": "92.68",
        "Date3": "81.90",
        "Date4": "78.06",
        "Date5": "92.51",
        "Date6": "94.26",
        "Date7": "96.62",
        "Date8": "99.31"
    },
    {
        "Item": "MCH",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "26.0",
        "AllowedMax": "36.4",
        "Unit": "pg",
        "SD": "2.16",
        "Mean": "31.20",
        "CV": "0.07",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "30.75",
        "Date1": "28.62",
        "Date2": "30.63",
        "Date3": "35.58",
        "Date4": "31.59",
        "Date5": "32.49",
        "Date6": "33.56",
        "Date7": "31.14",
        "Date8": "30.13"
    },
    {
        "Item": "MCHC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "33.6",
        "AllowedMax": "35.7",
        "Unit": "g/dL",
        "SD": "0.73",
        "Mean": "34.65",
        "CV": "0.02",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "34.62",
        "Date1": "33.72",
        "Date2": "33.63",
        "Date3": "33.85",
        "Date4": "33.68",
        "Date5": "35.37",
        "Date6": "35.08",
        "Date7": "34.65",
        "Date8": "35.04"
    },
    {
        "Item": "PLT",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "95.0",
        "AllowedMax": "471.0",
        "Unit": "x 10^3/μL",
        "SD": "68.05",
        "Mean": "283.00",
        "CV": "0.24",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "341.92",
        "Date1": "290.08",
        "Date2": "197.86",
        "Date3": "181.16",
        "Date4": "301.72",
        "Date5": "274.01",
        "Date6": "176.24",
        "Date7": "154.10",
        "Date8": "119.01"
    },
    {
        "Item": "RDW-SD",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "34.9",
        "AllowedMax": "65.7",
        "Unit": "fL",
        "SD": "6.54",
        "Mean": "50.30",
        "CV": "0.13",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "36.10",
        "Date1": "48.84",
        "Date2": "59.53",
        "Date3": "43.97",
        "Date4": "51.74",
        "Date5": "41.82",
        "Date6": "56.02",
        "Date7": "41.83",
        "Date8": "50.98"
    },
    {
        "Item": "RDW-CV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "13.3",
        "AllowedMax": "18.2",
        "Unit": "%",
        "SD": "1.32",
        "Mean": "15.75",
        "CV": "0.08",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "15.79",
        "Date1": "13.57",
        "Date2": "14.71",
        "Date3": "15.13",
        "Date4": "15.62",
        "Date5": "16.09",
        "Date6": "17.00",
        "Date7": "14.21",
        "Date8": "17.36"
    },
    {
        "Item": "MPV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "7.3",
        "AllowedMax": "9.9",
        "Unit": "fL",
        "SD": "0.72",
        "Mean": "8.60",
        "CV": "0.08",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "9.46",
        "Date1": "8.71",
        "Date2": "9.74",
        "Date3": "7.91",
        "Date4": "9.03",
        "Date5": "9.70",
        "Date6": "9.60",
        "Date7": "8.21",
        "Date8": "8.37"
    },
    {
        "Item": "NEUT no.",
        "Label": "NEUT#",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "2.2",
        "AllowedMax": "11.4",
        "Unit": "x 10^3/μL",
        "SD": "3.33",
        "Mean": "6.80",
        "CV": "0.49",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "9.60",
        "Date1": "2.27",
        "Date2": "8.21",
        "Date3": "2.26",
        "Date4": "3.55",
        "Date5": "2.36",
        "Date6": "11.14",
        "Date7": "2.78",
        "Date8": "5.86"
    },
    {
        "Item": "LYMPH no.",
        "Label": "LYMPH #",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.2",
        "AllowedMax": "5.7",
        "Unit": "x 10^3/μL",
        "SD": "1.57",
        "Mean": "3.45",
        "CV": "0.45",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "3.59",
        "Date1": "1.48",
        "Date2": "3.14",
        "Date3": "5.43",
        "Date4": "4.92",
        "Date5": "1.41",
        "Date6": "2.32",
        "Date7": "3.14",
        "Date8": "4.74"
    },
    {
        "Item": "MONO no.",
        "Label": "MONO #",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.1",
        "AllowedMax": "5.0",
        "Unit": "x 10^3/μL",
        "SD": "1.23",
        "Mean": "2.55",
        "CV": "0.48",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.29",
        "Date1": "1.18",
        "Date2": "1.22",
        "Date3": "0.63",
        "Date4": "2.83",
        "Date5": "2.13",
        "Date6": "1.61",
        "Date7": "3.17",
        "Date8": "4.30"
    },
    {
        "Item": "EO no.",
        "Label": "EO #",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.5",
        "Unit": "x 10^3/μL",
        "SD": "0.18",
        "Mean": "0.25",
        "CV": "0.70",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.08",
        "Date1": "0.04",
        "Date2": "0.49",
        "Date3": "0.31",
        "Date4": "0.15",
        "Date5": "0.04",
        "Date6": "0.02",
        "Date7": "0.33",
        "Date8": "0.06"
    },
    {
        "Item": "BASO no.",
        "Label": "BASO #",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.1",
        "Unit": "x 10^3/μL",
        "SD": "0.04",
        "Mean": "0.05",
        "CV": "0.71",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.09",
        "Date1": "0.09",
        "Date2": "0.06",
        "Date3": "0.01",
        "Date4": "0.00",
        "Date5": "0.03",
        "Date6": "0.06",
        "Date7": "0.02",
        "Date8": "0.10"
    },
    {
        "Item": "NEUTpercent",
        "Label": "NEUT%",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "14.6",
        "AllowedMax": "69.3",
        "Unit": "%",
        "SD": "10.65",
        "Mean": "41.95",
        "CV": "0.25",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "67.14",
        "Date1": "49.53",
        "Date2": "59.76",
        "Date3": "43.49",
        "Date4": "54.12",
        "Date5": "25.95",
        "Date6": "48.41",
        "Date7": "35.86",
        "Date8": "49.10"
    },
    {
        "Item": "LYMPH percent",
        "Label": "LYMPH %",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "8.0",
        "AllowedMax": "70.0",
        "Unit": "%",
        "SD": "21.92",
        "Mean": "39.00",
        "CV": "0.56",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "68.06",
        "Date1": "62.95",
        "Date2": "23.43",
        "Date3": "69.22",
        "Date4": "19.11",
        "Date5": "24.22",
        "Date6": "11.97",
        "Date7": "31.93",
        "Date8": "14.14"
    },
    {
        "Item": "MONO percent",
        "Label": "MONO %",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "4.0",
        "AllowedMax": "19.0",
        "Unit": "%",
        "SD": "2.66",
        "Mean": "11.50",
        "CV": "0.23",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "11.84",
        "Date1": "13.76",
        "Date2": "8.17",
        "Date3": "10.09",
        "Date4": "14.21",
        "Date5": "15.48",
        "Date6": "12.84",
        "Date7": "9.04",
        "Date8": "10.52"
    },
    {
        "Item": "EO percent",
        "Label": "EO %",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.0",
        "AllowedMax": "7.0",
        "Unit": "%",
        "SD": "2.06",
        "Mean": "4.00",
        "CV": "0.51",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.37",
        "Date1": "3.43",
        "Date2": "4.11",
        "Date3": "2.65",
        "Date4": "1.18",
        "Date5": "2.26",
        "Date6": "6.00",
        "Date7": "6.80",
        "Date8": "6.15"
    },
    {
        "Item": "BASO percent",
        "Label": "BASO %",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.0",
        "Unit": "%",
        "SD": "0.37",
        "Mean": "0.50",
        "CV": "0.75",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.42",
        "Date1": "0.10",
        "Date2": "0.84",
        "Date3": "0.61",
        "Date4": "0.84",
        "Date5": "0.99",
        "Date6": "0.87",
        "Date7": "0.89",
        "Date8": "0.03"
    },
    {
        "Item": "IG no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.28",
        "Unit": "x 10^3/μL%",
        "SD": "0.07",
        "Mean": "0.14",
        "CV": "0.48",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.16",
        "Date1": "0.14",
        "Date2": "0.04",
        "Date3": "0.13",
        "Date4": "0.17",
        "Date5": "0.10",
        "Date6": "0.10",
        "Date7": "0.23",
        "Date8": "0.23"
    },
    {
        "Item": "IG percent",
        "Label": "IG %",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.7",
        "Unit": "%",
        "SD": "0.44",
        "Mean": "0.85",
        "CV": "0.52",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.61",
        "Date1": "0.25",
        "Date2": "1.45",
        "Date3": "0.85",
        "Date4": "0.24",
        "Date5": "0.33",
        "Date6": "0.86",
        "Date7": "0.48",
        "Date8": "0.17"
    },
    {
        "Item": "RET no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "29.0",
        "AllowedMax": "120.0",
        "Unit": "x 10^6/μL",
        "SD": "15.13",
        "Mean": "74.50",
        "CV": "0.20",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "73.32",
        "Date1": "74.85",
        "Date2": "64.07",
        "Date3": "65.74",
        "Date4": "61.19",
        "Date5": "87.36",
        "Date6": "100.05",
        "Date7": "92.74",
        "Date8": "63.84"
    },
    {
        "Item": "RET percent",
        "Label": "RET %",
        "Structure -->": "",
        "Groups": "QC-001",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.4",
        "AllowedMax": "4.8",
        "Unit": "%",
        "SD": "1.38",
        "Mean": "2.60",
        "CV": "0.53",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.80",
        "Date1": "3.37",
        "Date2": "3.84",
        "Date3": "3.00",
        "Date4": "4.13",
        "Date5": "0.81",
        "Date6": "0.54",
        "Date7": "2.44",
        "Date8": "1.41"
    },
    {
        "Item": "QC-002",
        "Label": "",
        "Structure -->": "",
        "Groups": "QCSample",
        "Subgroup": "QCSample",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "OK",
        "Analysis dates -->": "8/1/2023 9:00:00; 9/9/2023 9:00:00; 9/15/2023 10:00:00",
        "Presenting": "11/16/2023 12:50:24",
        "Date1": "8/1/2023 9:00:00",
        "Date2": "9/9/2023 9:00:00",
        "Date3": "9/15/2023 10:00:00"
    },
    {
        "Item": "Material",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "SampleInfo",
        "Options -->": "",
        "Description": "XN-L Control Level 2"
    },
    {
        "Item": "Expiry Date",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "SampleInfo",
        "Options -->": "",
        "Description": "31/08/2023"
    },
    {
        "Item": "Cell Pack DCL",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "ReagentInfo"
    },
    {
        "Item": "Validated",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Output",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Rack no.",
        "Label": "Rack #",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Position",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Action",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Error",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "P / N",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "N",
        "Date1": "N",
        "Date2": "N",
        "Date3": "N"
    },
    {
        "Item": "WBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "5.9",
        "AllowedMax": "16.7",
        "Unit": "x 10^3/μL",
        "SD": "3.79",
        "Mean": "11.30",
        "CV": "0.34",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "7.00",
        "Date1": "6.00",
        "Date2": "7.00",
        "Date3": "13.00"
    },
    {
        "Item": "RBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "3.2",
        "AllowedMax": "5.1",
        "Unit": "x 10^6/μL",
        "SD": "0.00",
        "Mean": "4.16",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.00",
        "Date1": "4.00",
        "Date2": "4.00",
        "Date3": "4.00"
    },
    {
        "Item": "HGB",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "10.2",
        "AllowedMax": "16.6",
        "Unit": "g/dL",
        "SD": "1.15",
        "Mean": "13.40",
        "CV": "0.09",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "11.00",
        "Date1": "11.00",
        "Date2": "11.00",
        "Date3": "13.00"
    },
    {
        "Item": "HCT",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "29.1",
        "AllowedMax": "47.7",
        "Unit": "%",
        "SD": "4.04",
        "Mean": "38.40",
        "CV": "0.11",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "30.00",
        "Date1": "30.00",
        "Date2": "30.00",
        "Date3": "37.00"
    },
    {
        "Item": "MCV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "75.6",
        "AllowedMax": "106.3",
        "Unit": "fL",
        "SD": "10.15",
        "Mean": "90.95",
        "CV": "0.11",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "100.00",
        "Date1": "80.00",
        "Date2": "100.00",
        "Date3": "87.00"
    },
    {
        "Item": "MCH",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "26.0",
        "AllowedMax": "36.4",
        "Unit": "pg",
        "SD": "1.73",
        "Mean": "31.20",
        "CV": "0.06",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "30.00",
        "Date1": "30.00",
        "Date2": "30.00",
        "Date3": "33.00"
    },
    {
        "Item": "MCHC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "33.6",
        "AllowedMax": "35.7",
        "Unit": "g/dL",
        "SD": "0.00",
        "Mean": "34.65",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "35.00",
        "Date1": "35.00",
        "Date2": "35.00",
        "Date3": "35.00"
    },
    {
        "Item": "PLT",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "95.0",
        "AllowedMax": "471.0",
        "Unit": "x 10^3/μL",
        "SD": "213.04",
        "Mean": "283.00",
        "CV": "0.75",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "115.00",
        "Date1": "100.00",
        "Date2": "100.00",
        "Date3": "469.00"
    },
    {
        "Item": "RDW-SD",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "34.9",
        "AllowedMax": "65.7",
        "Unit": "fL",
        "SD": "1.15",
        "Mean": "50.30",
        "CV": "0.02",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "60.00",
        "Date1": "60.00",
        "Date2": "60.00",
        "Date3": "58.00"
    },
    {
        "Item": "RDW-CV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "13.3",
        "AllowedMax": "18.2",
        "Unit": "%",
        "SD": "0.58",
        "Mean": "15.75",
        "CV": "0.04",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "15.00",
        "Date1": "15.00",
        "Date2": "15.00",
        "Date3": "16.00"
    },
    {
        "Item": "MPV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "7.3",
        "AllowedMax": "9.9",
        "Unit": "fL",
        "SD": "0.00",
        "Mean": "8.60",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "9.00",
        "Date1": "9.00",
        "Date2": "9.00",
        "Date3": "9.00"
    },
    {
        "Item": "NEUT no.",
        "Label": "NEUT#",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "2.2",
        "AllowedMax": "11.4",
        "Unit": "x 10^3/μL",
        "SD": "1.00",
        "Mean": "6.80",
        "CV": "0.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "3.00",
        "Date1": "5.00",
        "Date2": "3.00",
        "Date3": "4.00"
    },
    {
        "Item": "LYMPH no.",
        "Label": "LYMPH #",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.2",
        "AllowedMax": "5.7",
        "Unit": "x 10^3/μL",
        "SD": "0.58",
        "Mean": "3.45",
        "CV": "0.17",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "5.00",
        "Date1": "5.00",
        "Date2": "5.00",
        "Date3": "4.00"
    },
    {
        "Item": "MONO no.",
        "Label": "MONO #",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.1",
        "AllowedMax": "5.0",
        "Unit": "x 10^3/μL",
        "SD": "2.31",
        "Mean": "2.55",
        "CV": "0.91",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "5.00",
        "Date1": "5.00",
        "Date2": "5.00",
        "Date3": "1.00"
    },
    {
        "Item": "EO no.",
        "Label": "EO #",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.5",
        "Unit": "x 10^3/μL",
        "SD": "0.29",
        "Mean": "0.25",
        "CV": "1.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.50",
        "Date1": "0.50",
        "Date2": "0.50",
        "Date3": "0.00"
    },
    {
        "Item": "BASO no.",
        "Label": "BASO #",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.1",
        "Unit": "x 10^3/μL",
        "SD": "0.06",
        "Mean": "0.05",
        "CV": "1.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.10",
        "Date1": "0.10",
        "Date2": "0.10",
        "Date3": "0.00"
    },
    {
        "Item": "NEUTpercent",
        "Label": "NEUT%",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "14.6",
        "AllowedMax": "69.3",
        "Unit": "%",
        "SD": "29.44",
        "Mean": "41.95",
        "CV": "0.70",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "69.00",
        "Date1": "69.00",
        "Date2": "69.00",
        "Date3": "18.00"
    },
    {
        "Item": "LYMPH percent",
        "Label": "LYMPH %",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "8.0",
        "AllowedMax": "70.0",
        "Unit": "%",
        "SD": "27.14",
        "Mean": "39.00",
        "CV": "0.70",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "70.00",
        "Date1": "70.00",
        "Date2": "70.00",
        "Date3": "23.00"
    },
    {
        "Item": "MONO percent",
        "Label": "MONO %",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "4.0",
        "AllowedMax": "19.0",
        "Unit": "%",
        "SD": "2.31",
        "Mean": "11.50",
        "CV": "0.20",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "19.00",
        "Date1": "19.00",
        "Date2": "19.00",
        "Date3": "15.00"
    },
    {
        "Item": "EO percent",
        "Label": "EO %",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.0",
        "AllowedMax": "7.0",
        "Unit": "%",
        "SD": "3.46",
        "Mean": "4.00",
        "CV": "0.87",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "7.00",
        "Date1": "7.00",
        "Date2": "7.00",
        "Date3": "1.00"
    },
    {
        "Item": "BASO percent",
        "Label": "BASO %",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.0",
        "Unit": "%",
        "SD": "0.58",
        "Mean": "0.50",
        "CV": "1.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.00",
        "Date1": "1.00",
        "Date2": "1.00",
        "Date3": "0.00"
    },
    {
        "Item": "IG no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.28",
        "Unit": "x 10^3/μL%",
        "SD": "0.12",
        "Mean": "0.14",
        "CV": "0.82",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.20",
        "Date1": "0.20",
        "Date2": "0.20",
        "Date3": "0.00"
    },
    {
        "Item": "IG percent",
        "Label": "IG %",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.7",
        "Unit": "%",
        "SD": "0.00",
        "Mean": "0.85",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.00",
        "Date1": "1.00",
        "Date2": "1.00",
        "Date3": "1.00"
    },
    {
        "Item": "RET no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "29.0",
        "AllowedMax": "120.0",
        "Unit": "x 10^6/μL",
        "SD": "1.15",
        "Mean": "74.50",
        "CV": "0.02",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "100.00",
        "Date1": "100.00",
        "Date2": "100.00",
        "Date3": "102.00"
    },
    {
        "Item": "RET percent",
        "Label": "RET %",
        "Structure -->": "",
        "Groups": "QC-002",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.4",
        "AllowedMax": "4.8",
        "Unit": "%",
        "SD": "1.73",
        "Mean": "2.60",
        "CV": "0.67",
        "Status": "2.6",
        "Analysis dates -->": "",
        "Presenting": "1.00",
        "Date1": "1.00",
        "Date2": "1.00",
        "Date3": "4.00"
    },
    {
        "Item": "QC-003",
        "Label": "",
        "Structure -->": "",
        "Groups": "QCSample",
        "Subgroup": "QCSample",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "Err-range",
        "Analysis dates -->": "8/1/2023 9:00:00; 9/9/2023 9:00:00; 9/15/2023 10:00:00",
        "Presenting": "11/16/2023 12:50:24",
        "Date1": "8/1/2023 9:00:00",
        "Date2": "9/9/2023 9:00:00",
        "Date3": "9/15/2023 10:00:00"
    },
    {
        "Item": "Material",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "SampleInfo",
        "Options -->": "",
        "Description": "XN-L Control Level 3"
    },
    {
        "Item": "Expiry Date",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "SampleInfo",
        "Options -->": "",
        "Description": "31/08/2023"
    },
    {
        "Item": "Cell Pack DCL",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "ReagentInfo"
    },
    {
        "Item": "Validated",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Output",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Rack no.",
        "Label": "Rack #",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Position",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Action",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Error",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "P / N",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "N",
        "Date1": "N",
        "Date2": "N",
        "Date3": "N"
    },
    {
        "Item": "WBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "5.9",
        "AllowedMax": "16.7",
        "Unit": "x 10^3/μL",
        "SD": "5.69",
        "Mean": "11.30",
        "CV": "0.50",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "7.00",
        "Date1": "6.00",
        "Date2": "17.00",
        "Date3": "14.00"
    },
    {
        "Item": "RBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "3.2",
        "AllowedMax": "5.1",
        "Unit": "x 10^6/μL",
        "SD": "0.58",
        "Mean": "4.16",
        "CV": "0.14",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.00",
        "Date1": "4.00",
        "Date2": "4.00",
        "Date3": "5.00"
    },
    {
        "Item": "HGB",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "10.2",
        "AllowedMax": "16.6",
        "Unit": "g/dL",
        "SD": "1.15",
        "Mean": "13.40",
        "CV": "0.09",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "11.00",
        "Date1": "11.00",
        "Date2": "11.00",
        "Date3": "13.00"
    },
    {
        "Item": "HCT",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "29.1",
        "AllowedMax": "47.7",
        "Unit": "%",
        "SD": "6.93",
        "Mean": "38.40",
        "CV": "0.18",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "30.00",
        "Date1": "30.00",
        "Date2": "30.00",
        "Date3": "42.00"
    },
    {
        "Item": "MCV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "75.6",
        "AllowedMax": "106.3",
        "Unit": "fL",
        "SD": "13.28",
        "Mean": "90.95",
        "CV": "0.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "100.00",
        "Date1": "100.00",
        "Date2": "100.00",
        "Date3": "77.00"
    },
    {
        "Item": "MCH",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "26.0",
        "AllowedMax": "36.4",
        "Unit": "pg",
        "SD": "2.31",
        "Mean": "31.20",
        "CV": "0.07",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "30.00",
        "Date1": "30.00",
        "Date2": "30.00",
        "Date3": "26.00"
    },
    {
        "Item": "MCHC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "33.6",
        "AllowedMax": "35.7",
        "Unit": "g/dL",
        "SD": "2.31",
        "Mean": "34.65",
        "CV": "0.07",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "35.00",
        "Date1": "35.00",
        "Date2": "35.00",
        "Date3": "31.00"
    },
    {
        "Item": "PLT",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "95.0",
        "AllowedMax": "471.0",
        "Unit": "x 10^3/μL",
        "SD": "107.39",
        "Mean": "283.00",
        "CV": "0.38",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "115.00",
        "Date1": "100.00",
        "Date2": "100.00",
        "Date3": "286.00"
    },
    {
        "Item": "RDW-SD",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "34.9",
        "AllowedMax": "65.7",
        "Unit": "fL",
        "SD": "11.55",
        "Mean": "50.30",
        "CV": "0.23",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "60.00",
        "Date1": "60.00",
        "Date2": "60.00",
        "Date3": "40.00"
    },
    {
        "Item": "RDW-CV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "13.3",
        "AllowedMax": "18.2",
        "Unit": "%",
        "SD": "1.73",
        "Mean": "15.75",
        "CV": "0.11",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "15.00",
        "Date1": "15.00",
        "Date2": "15.00",
        "Date3": "12.00"
    },
    {
        "Item": "MPV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "7.3",
        "AllowedMax": "9.9",
        "Unit": "fL",
        "SD": "1.15",
        "Mean": "8.60",
        "CV": "0.13",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "9.00",
        "Date1": "9.00",
        "Date2": "9.00",
        "Date3": "7.00"
    },
    {
        "Item": "NEUT no.",
        "Label": "NEUT#",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "2.2",
        "AllowedMax": "11.4",
        "Unit": "x 10^3/μL",
        "SD": "2.00",
        "Mean": "6.80",
        "CV": "0.29",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "3.00",
        "Date1": "5.00",
        "Date2": "3.00",
        "Date3": "7.00"
    },
    {
        "Item": "LYMPH no.",
        "Label": "LYMPH #",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.2",
        "AllowedMax": "5.7",
        "Unit": "x 10^3/μL",
        "SD": "1.15",
        "Mean": "3.45",
        "CV": "0.33",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "5.00",
        "Date1": "5.00",
        "Date2": "5.00",
        "Date3": "3.00"
    },
    {
        "Item": "MONO no.",
        "Label": "MONO #",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.1",
        "AllowedMax": "5.0",
        "Unit": "x 10^3/μL",
        "SD": "1.15",
        "Mean": "2.55",
        "CV": "0.45",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "5.00",
        "Date1": "5.00",
        "Date2": "5.00",
        "Date3": "3.00"
    },
    {
        "Item": "EO no.",
        "Label": "EO #",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.5",
        "Unit": "x 10^3/μL",
        "SD": "0.29",
        "Mean": "0.25",
        "CV": "1.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.50",
        "Date1": "0.50",
        "Date2": "0.50",
        "Date3": "0.00"
    },
    {
        "Item": "BASO no.",
        "Label": "BASO #",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.1",
        "Unit": "x 10^3/μL",
        "SD": "0.06",
        "Mean": "0.05",
        "CV": "1.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.10",
        "Date1": "0.10",
        "Date2": "0.10",
        "Date3": "0.00"
    },
    {
        "Item": "NEUTpercent",
        "Label": "NEUT%",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "14.6",
        "AllowedMax": "69.3",
        "Unit": "%",
        "SD": "28.87",
        "Mean": "41.95",
        "CV": "0.69",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "69.00",
        "Date1": "69.00",
        "Date2": "69.00",
        "Date3": "19.00"
    },
    {
        "Item": "LYMPH percent",
        "Label": "LYMPH %",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "8.0",
        "AllowedMax": "70.0",
        "Unit": "%",
        "SD": "31.75",
        "Mean": "39.00",
        "CV": "0.81",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "70.00",
        "Date1": "70.00",
        "Date2": "70.00",
        "Date3": "15.00"
    },
    {
        "Item": "MONO percent",
        "Label": "MONO %",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "4.0",
        "AllowedMax": "19.0",
        "Unit": "%",
        "SD": "5.77",
        "Mean": "11.50",
        "CV": "0.50",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "19.00",
        "Date1": "19.00",
        "Date2": "19.00",
        "Date3": "9.00"
    },
    {
        "Item": "EO percent",
        "Label": "EO %",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.0",
        "AllowedMax": "7.0",
        "Unit": "%",
        "SD": "1.15",
        "Mean": "4.00",
        "CV": "0.29",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "7.00",
        "Date1": "7.00",
        "Date2": "7.00",
        "Date3": "5.00"
    },
    {
        "Item": "BASO percent",
        "Label": "BASO %",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.0",
        "Unit": "%",
        "SD": "0.58",
        "Mean": "0.50",
        "CV": "1.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.00",
        "Date1": "1.00",
        "Date2": "1.00",
        "Date3": "0.00"
    },
    {
        "Item": "IG no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.28",
        "Unit": "x 10^3/μL%",
        "SD": "0.12",
        "Mean": "0.14",
        "CV": "0.82",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.20",
        "Date1": "0.20",
        "Date2": "0.20",
        "Date3": "0.00"
    },
    {
        "Item": "IG percent",
        "Label": "IG %",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.7",
        "Unit": "%",
        "SD": "0.00",
        "Mean": "0.85",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.00",
        "Date1": "1.00",
        "Date2": "1.00",
        "Date3": "1.00"
    },
    {
        "Item": "RET no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "29.0",
        "AllowedMax": "120.0",
        "Unit": "x 10^6/μL",
        "SD": "25.40",
        "Mean": "74.50",
        "CV": "0.34",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "100.00",
        "Date1": "100.00",
        "Date2": "100.00",
        "Date3": "56.00"
    },
    {
        "Item": "RET percent",
        "Label": "RET %",
        "Structure -->": "",
        "Groups": "QC-003",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.4",
        "AllowedMax": "4.8",
        "Unit": "%",
        "SD": "0.58",
        "Mean": "2.60",
        "CV": "0.22",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.00",
        "Date1": "1.00",
        "Date2": "1.00",
        "Date3": "2.00"
    },
    {
        "Item": "QC-004",
        "Label": "",
        "Structure -->": "",
        "Groups": "QCSample",
        "Subgroup": "QCSample",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "Err-range",
        "Analysis dates -->": "8/1/2023 9:00:00",
        "Presenting": "11/16/2023 12:50:24",
        "Date1": "8/1/2023 9:00:00"
    },
    {
        "Item": "Material",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "SampleInfo",
        "Options -->": "",
        "Description": "XN-L Control Level 4"
    },
    {
        "Item": "Expiry Date",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "SampleInfo",
        "Options -->": "",
        "Description": "31/12/2023"
    },
    {
        "Item": "Cell Pack DCL",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "ReagentInfo"
    },
    {
        "Item": "Validated",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Output",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Rack no.",
        "Label": "Rack #",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Position",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Action",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Error",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "P / N",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "P",
        "Date2": "P"
    },
    {
        "Item": "WBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "5.9",
        "AllowedMax": "16.7",
        "Unit": "x 10^3/μL",
        "SD": "0.00",
        "Mean": "11.30",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "5.00",
        "Date2": "5.00"
    },
    {
        "Item": "RBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "3.2",
        "AllowedMax": "5.1",
        "Unit": "x 10^6/μL",
        "SD": "0.00",
        "Mean": "4.16",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "4.00",
        "Date2": "4.00"
    },
    {
        "Item": "HGB",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "10.2",
        "AllowedMax": "16.6",
        "Unit": "g/dL",
        "SD": "0.00",
        "Mean": "13.40",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "11.00",
        "Date2": "11.00"
    },
    {
        "Item": "HCT",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "29.1",
        "AllowedMax": "47.7",
        "Unit": "%",
        "SD": "0.00",
        "Mean": "38.40",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "30.00",
        "Date2": "30.00"
    },
    {
        "Item": "MCV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "75.6",
        "AllowedMax": "106.3",
        "Unit": "fL",
        "SD": "0.00",
        "Mean": "90.95",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "100.00",
        "Date2": "100.00"
    },
    {
        "Item": "MCH",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "26.0",
        "AllowedMax": "36.4",
        "Unit": "pg",
        "SD": "0.00",
        "Mean": "31.20",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "30.00",
        "Date2": "30.00"
    },
    {
        "Item": "MCHC",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "33.6",
        "AllowedMax": "35.7",
        "Unit": "g/dL",
        "SD": "0.00",
        "Mean": "34.65",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "35.00",
        "Date2": "35.00"
    },
    {
        "Item": "PLT",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "95.0",
        "AllowedMax": "471.0",
        "Unit": "x 10^3/μL",
        "SD": "0.00",
        "Mean": "283.00",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "100.00",
        "Date2": "100.00"
    },
    {
        "Item": "RDW-SD",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "34.9",
        "AllowedMax": "65.7",
        "Unit": "fL",
        "SD": "0.00",
        "Mean": "50.30",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "60.00",
        "Date2": "60.00"
    },
    {
        "Item": "RDW-CV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "13.3",
        "AllowedMax": "18.2",
        "Unit": "%",
        "SD": "0.00",
        "Mean": "15.75",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "15.00",
        "Date2": "15.00"
    },
    {
        "Item": "MPV",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "7.3",
        "AllowedMax": "9.9",
        "Unit": "fL",
        "SD": "0.00",
        "Mean": "8.60",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "9.00",
        "Date2": "9.00"
    },
    {
        "Item": "NEUT no.",
        "Label": "NEUT#",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "2.2",
        "AllowedMax": "11.4",
        "Unit": "x 10^3/μL",
        "SD": "0.00",
        "Mean": "6.80",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "5.00",
        "Date2": "5.00"
    },
    {
        "Item": "LYMPH no.",
        "Label": "LYMPH #",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.2",
        "AllowedMax": "5.7",
        "Unit": "x 10^3/μL",
        "SD": "0.00",
        "Mean": "3.45",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "5.00",
        "Date2": "5.00"
    },
    {
        "Item": "MONO no.",
        "Label": "MONO #",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.1",
        "AllowedMax": "5.0",
        "Unit": "x 10^3/μL",
        "SD": "0.00",
        "Mean": "2.55",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "5.00",
        "Date2": "5.00"
    },
    {
        "Item": "EO no.",
        "Label": "EO #",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.5",
        "Unit": "x 10^3/μL",
        "SD": "0.00",
        "Mean": "0.25",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "0.50",
        "Date2": "0.50"
    },
    {
        "Item": "BASO no.",
        "Label": "BASO #",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.1",
        "Unit": "x 10^3/μL",
        "SD": "0.00",
        "Mean": "0.05",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "0.10",
        "Date2": "0.10"
    },
    {
        "Item": "NEUTpercent",
        "Label": "NEUT%",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "14.6",
        "AllowedMax": "69.3",
        "Unit": "%",
        "SD": "0.00",
        "Mean": "41.95",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "69.00",
        "Date2": "69.00"
    },
    {
        "Item": "LYMPH percent",
        "Label": "LYMPH %",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "8.0",
        "AllowedMax": "70.0",
        "Unit": "%",
        "SD": "0.00",
        "Mean": "39.00",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "70.00",
        "Date2": "70.00"
    },
    {
        "Item": "MONO percent",
        "Label": "MONO %",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "4.0",
        "AllowedMax": "19.0",
        "Unit": "%",
        "SD": "0.00",
        "Mean": "11.50",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "19.00",
        "Date2": "19.00"
    },
    {
        "Item": "EO percent",
        "Label": "EO %",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.0",
        "AllowedMax": "7.0",
        "Unit": "%",
        "SD": "0.00",
        "Mean": "4.00",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "7.00",
        "Date2": "7.00"
    },
    {
        "Item": "BASO percent",
        "Label": "BASO %",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.0",
        "Unit": "%",
        "SD": "0.00",
        "Mean": "0.50",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "1.00",
        "Date2": "1.00"
    },
    {
        "Item": "IG no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.28",
        "Unit": "x 10^3/μL%",
        "SD": "0.00",
        "Mean": "0.14",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "0.20",
        "Date2": "0.20"
    },
    {
        "Item": "IG percent",
        "Label": "IG %",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.7",
        "Unit": "%",
        "SD": "0.00",
        "Mean": "0.85",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "1.00",
        "Date2": "1.00"
    },
    {
        "Item": "RET no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "29.0",
        "AllowedMax": "120.0",
        "Unit": "x 10^6/μL",
        "SD": "0.00",
        "Mean": "74.50",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "100.00",
        "Date2": "100.00"
    },
    {
        "Item": "RET percent",
        "Label": "RET %",
        "Structure -->": "",
        "Groups": "QC-004",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.4",
        "AllowedMax": "4.8",
        "Unit": "%",
        "SD": "0.00",
        "Mean": "2.60",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "1.00",
        "Date2": "1.00"
    },
    {},
    {
        "Item": "P12345",
        "Label": "",
        "Structure -->": "",
        "Groups": "MASample",
        "Subgroup": "MASample",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "Err-range",
        "Analysis dates -->": "8/1/2023 11:27:55; 9/1/2023 1:27:56; 10/1/2023 11:27:56",
        "Presenting": "11/16/2023 12:50:24",
        "Date1": "8/1/2023 11:27:55",
        "Date2": "9/1/2023 1:27:56",
        "Date3": "10/1/2023 11:27:56"
    },
    {
        "Item": "MRN",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "112233"
    },
    {
        "Item": "First Name",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "Jon"
    },
    {
        "Item": "Last Name",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "Doe"
    },
    {
        "Item": "Gender",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "M"
    },
    {
        "Item": "age",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "50"
    },
    {
        "Item": "ward",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "7"
    },
    {
        "Item": "doctor",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "M.D"
    },
    {
        "Item": "Cell Pack DCL",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "ReagentInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "Y3006",
        "Date1": "Y3007",
        "Date2": "Y3008",
        "Date3": "Y3009"
    },
    {
        "Item": "Sulfoyser",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "ReagentInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "A2014",
        "Date1": "A2015",
        "Date2": "A2016",
        "Date3": "A2017"
    },
    {
        "Item": "Lysercell WDF",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "ReagentInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "Y2061",
        "Date1": "Y2062",
        "Date2": "Y2063",
        "Date3": "Y2064"
    },
    {
        "Item": "Validated",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "V",
        "Date2": "V"
    },
    {
        "Item": "Output",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "GH",
        "Date2": "G"
    },
    {
        "Item": "Rack no.",
        "Label": "Rack #",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "2"
    },
    {
        "Item": "Position",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "1"
    },
    {
        "Item": "Action",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "",
        "Date2": "",
        "Date3": "recommend another method"
    },
    {
        "Item": "Error",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "",
        "Date2": "",
        "Date3": "an error"
    },
    {
        "Item": "P / N",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "N",
        "Date1": "N",
        "Date2": "N",
        "Date3": "P"
    },
    {
        "Item": "Flags",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "Other",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "WBC Abn Scg, \nBl/Abn Ly? (250),\nAniso\nHypochromia\n"
    },
    {
        "Item": "Graph",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "Other",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "",
        "Date1": "https://healthcare-in-europe.com/media/story_section_image/2556/image-01-beck2.jpg"
    },
    {
        "Item": "WBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "5.9",
        "AllowedMax": "16.7",
        "Unit": "x 10^3/μL",
        "SD": "5.45",
        "Mean": "11.30",
        "CV": "0.48",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "6.87",
        "Date1": "5.9",
        "Date2": "16.7",
        "Date3": "10.00"
    },
    {
        "Item": "RBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "3.2",
        "AllowedMax": "5.1",
        "Unit": "x 10^6/μL",
        "SD": "0.92",
        "Mean": "4.16",
        "CV": "0.22",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.46",
        "Date1": "3.2",
        "Date2": "5.1",
        "Date3": "4.00"
    },
    {
        "Item": "HGB",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "10.2",
        "AllowedMax": "16.6",
        "Unit": "g/dL",
        "SD": "3.49",
        "Mean": "13.40",
        "CV": "0.26",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "9.5",
        "Date1": "10.2",
        "Date2": "16.6",
        "Date3": "11.00"
    },
    {
        "Item": "HCT",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.0",
        "Unit": "L/L",
        "SD": "18.77",
        "Mean": "0.50",
        "CV": "37.54",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.292",
        "Date1": "0.0",
        "Date2": "1.0",
        "Date3": "33.00"
    },
    {
        "Item": "MCV",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "75.6",
        "AllowedMax": "106.3",
        "Unit": "fL",
        "SD": "15.36",
        "Mean": "90.95",
        "CV": "0.17",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "78",
        "Date1": "75.6",
        "Date2": "106.3",
        "Date3": "92.00"
    },
    {
        "Item": "MCH",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "26.0",
        "AllowedMax": "36.4",
        "Unit": "pg",
        "SD": "5.35",
        "Mean": "31.20",
        "CV": "0.17",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "26",
        "Date1": "26.0",
        "Date2": "36.4",
        "Date3": "29.00"
    },
    {
        "Item": "MCHC",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "33.6",
        "AllowedMax": "35.7",
        "Unit": "g/dL",
        "SD": "1.12",
        "Mean": "34.65",
        "CV": "0.03",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "34",
        "Date1": "33.6",
        "Date2": "35.7",
        "Date3": "34.00"
    },
    {
        "Item": "PLT",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "95.0",
        "AllowedMax": "471.0",
        "Unit": "x 10^3/μL",
        "SD": "206.99",
        "Mean": "283.00",
        "CV": "0.73",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "211",
        "Date1": "95.0",
        "Date2": "471.0",
        "Date3": "433.00"
    },
    {
        "Item": "RDW-SD",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "34.9",
        "AllowedMax": "65.7",
        "Unit": "fL",
        "SD": "17.58",
        "Mean": "50.30",
        "CV": "0.35",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "46.2",
        "Date1": "34.9",
        "Date2": "65.7",
        "Date3": "65.00"
    },
    {
        "Item": "RDW-CV",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "13.3",
        "AllowedMax": "18.2",
        "Unit": "%",
        "SD": "2.65",
        "Mean": "15.75",
        "CV": "0.17",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "14",
        "Date1": "13.3",
        "Date2": "18.2",
        "Date3": "14.00"
    },
    {
        "Item": "MPV",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "7.3",
        "AllowedMax": "9.9",
        "Unit": "fL",
        "SD": "1.32",
        "Mean": "8.60",
        "CV": "0.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "8",
        "Date1": "7.3",
        "Date2": "9.9",
        "Date3": "9.00"
    },
    {
        "Item": "NEUT no.",
        "Label": "NEUT#",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "2.2",
        "AllowedMax": "11.4",
        "Unit": "x 10^3/μL",
        "SD": "4.77",
        "Mean": "6.80",
        "CV": "0.70",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.33",
        "Date1": "2.2",
        "Date2": "11.4",
        "Date3": "9.00"
    },
    {
        "Item": "LYMPH no.",
        "Label": "LYMPH #",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.2",
        "AllowedMax": "5.7",
        "Unit": "x 10^3/μL",
        "SD": "2.27",
        "Mean": "3.45",
        "CV": "0.66",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.32",
        "Date1": "1.2",
        "Date2": "5.7",
        "Date3": "4.00"
    },
    {
        "Item": "MONO no.",
        "Label": "MONO #",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.1",
        "AllowedMax": "5.0",
        "Unit": "x 10^3/μL",
        "SD": "2.46",
        "Mean": "2.55",
        "CV": "0.97",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.91",
        "Date1": "0.1",
        "Date2": "5.0",
        "Date3": "3.00"
    },
    {
        "Item": "EO no.",
        "Label": "EO #",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.5",
        "Unit": "x 10^3/μL",
        "SD": "0.29",
        "Mean": "0.25",
        "CV": "1.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.28",
        "Date1": "0.0",
        "Date2": "0.5",
        "Date3": "0.00"
    },
    {
        "Item": "BASO no.",
        "Label": "BASO #",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.1",
        "Unit": "x 10^3/μL",
        "SD": "0.06",
        "Mean": "0.05",
        "CV": "1.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.03",
        "Date1": "0.0",
        "Date2": "0.1",
        "Date3": "0.00"
    },
    {
        "Item": "NEUT percent",
        "Label": "NEUT%",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "14.6",
        "AllowedMax": "69.3",
        "Unit": "%",
        "SD": "29.48",
        "Mean": "41.95",
        "CV": "0.70",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "63.1",
        "Date1": "14.6",
        "Date2": "69.3",
        "Date3": "61.00"
    },
    {
        "Item": "LYMPH percent",
        "Label": "LYMPH %",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "8.0",
        "AllowedMax": "70.0",
        "Unit": "%",
        "SD": "32.52",
        "Mean": "39.00",
        "CV": "0.83",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "19.2",
        "Date1": "8.0",
        "Date2": "70.0",
        "Date3": "56.00"
    },
    {
        "Item": "MONO percent",
        "Label": "MONO %",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "4.0",
        "AllowedMax": "19.0",
        "Unit": "%",
        "SD": "7.51",
        "Mean": "11.50",
        "CV": "0.65",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "13.2",
        "Date1": "4.0",
        "Date2": "19.0",
        "Date3": "12.00"
    },
    {
        "Item": "EO percent",
        "Label": "EO %",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.0",
        "AllowedMax": "7.0",
        "Unit": "%",
        "SD": "3.21",
        "Mean": "4.00",
        "CV": "0.80",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.1",
        "Date1": "1.0",
        "Date2": "7.0",
        "Date3": "2.00"
    },
    {
        "Item": "BASO percent",
        "Label": "BASO %",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.0",
        "Unit": "%",
        "SD": "0.58",
        "Mean": "0.50",
        "CV": "1.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.4",
        "Date1": "0.0",
        "Date2": "1.0",
        "Date3": "0.00"
    },
    {
        "Item": "IG no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.28",
        "Unit": "x 10^9/L%",
        "SD": "0.16",
        "Mean": "0.14",
        "CV": "1.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.07",
        "Date1": "0.0",
        "Date2": "0.28",
        "Date3": "0.00"
    },
    {
        "Item": "IG percent",
        "Label": "IG %",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.7",
        "Unit": "%",
        "SD": "0.98",
        "Mean": "0.85",
        "CV": "1.15",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.6",
        "Date1": "0.0",
        "Date2": "1.7",
        "Date3": "0.00"
    },
    {
        "Item": "RET no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "29.0",
        "AllowedMax": "120.0",
        "Unit": "x 10^6/μL",
        "SD": "45.98",
        "Mean": "74.50",
        "CV": "0.62",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "100",
        "Date1": "29.0",
        "Date2": "120.0",
        "Date3": "63.00"
    },
    {
        "Item": "RET percent",
        "Label": "RET %",
        "Structure -->": "",
        "Groups": "P12345",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.4",
        "AllowedMax": "4.8",
        "Unit": "%",
        "SD": "2.34",
        "Mean": "2.60",
        "CV": "0.90",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.01",
        "Date1": "0.4",
        "Date2": "4.8",
        "Date3": "4.00"
    },
    {
        "Item": "P11111",
        "Label": "",
        "Structure -->": "",
        "Groups": "PASample",
        "Subgroup": "PASample",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "Err-range",
        "Analysis dates -->": "",
        "Presenting": "11/16/2023 12:50:24"
    },
    {
        "Item": "MRN",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "011-11"
    },
    {
        "Item": "First Name",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "One"
    },
    {
        "Item": "Last Name",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "Patient"
    },
    {
        "Item": "Gender",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "F"
    },
    {
        "Item": "age",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "25"
    },
    {
        "Item": "ward",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "7"
    },
    {
        "Item": "doctor",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "M.D"
    },
    {
        "Item": "Cell Pack DCL",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "ReagentInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "Y3006"
    },
    {
        "Item": "Sulfoyser",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "ReagentInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "A2014"
    },
    {
        "Item": "Lysercell WDF",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "ReagentInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "Y2061"
    },
    {
        "Item": "Validated",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Output",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Rack no.",
        "Label": "Rack #",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1"
    },
    {
        "Item": "Position",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1"
    },
    {
        "Item": "Action",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Error",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "P / N",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "N"
    },
    {
        "Item": "Flags",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "Other"
    },
    {
        "Item": "Graph",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "Other"
    },
    {
        "Item": "WBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "5.9",
        "AllowedMax": "16.7",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "11.30",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "6.87"
    },
    {
        "Item": "RBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "3.2",
        "AllowedMax": "5.1",
        "Unit": "x 10^6/μL",
        "SD": "0",
        "Mean": "4.16",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.46"
    },
    {
        "Item": "HGB",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "10.2",
        "AllowedMax": "16.6",
        "Unit": "g/dL",
        "SD": "0",
        "Mean": "13.40",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "9.5"
    },
    {
        "Item": "HCT",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.0",
        "Unit": "L/L",
        "SD": "0",
        "Mean": "0.50",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.292"
    },
    {
        "Item": "MCV",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "75.6",
        "AllowedMax": "106.3",
        "Unit": "fL",
        "SD": "0",
        "Mean": "90.95",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "78"
    },
    {
        "Item": "MCH",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "26.0",
        "AllowedMax": "36.4",
        "Unit": "pg",
        "SD": "0",
        "Mean": "31.20",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "26"
    },
    {
        "Item": "MCHC",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "33.6",
        "AllowedMax": "35.7",
        "Unit": "g/dL",
        "SD": "0",
        "Mean": "34.65",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "34"
    },
    {
        "Item": "PLT",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "95.0",
        "AllowedMax": "471.0",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "283.00",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "211"
    },
    {
        "Item": "RDW-SD",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "34.9",
        "AllowedMax": "65.7",
        "Unit": "fL",
        "SD": "0",
        "Mean": "50.30",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "46.2"
    },
    {
        "Item": "RDW-CV",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "13.3",
        "AllowedMax": "18.2",
        "Unit": "%",
        "SD": "0",
        "Mean": "15.75",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "14"
    },
    {
        "Item": "MPV",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "7.3",
        "AllowedMax": "9.9",
        "Unit": "fL",
        "SD": "0",
        "Mean": "8.60",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "8"
    },
    {
        "Item": "NEUT no.",
        "Label": "NEUT#",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "2.2",
        "AllowedMax": "11.4",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "6.80",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.33"
    },
    {
        "Item": "LYMPH no.",
        "Label": "LYMPH #",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.2",
        "AllowedMax": "5.7",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "3.45",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.32"
    },
    {
        "Item": "MONO no.",
        "Label": "MONO #",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.1",
        "AllowedMax": "5.0",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "2.55",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.91"
    },
    {
        "Item": "EO no.",
        "Label": "EO #",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.5",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "0.25",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.28"
    },
    {
        "Item": "BASO no.",
        "Label": "BASO #",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.1",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "0.05",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.03"
    },
    {
        "Item": "NEUT percent",
        "Label": "NEUT%",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "14.6",
        "AllowedMax": "69.3",
        "Unit": "%",
        "SD": "0",
        "Mean": "41.95",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "63.1"
    },
    {
        "Item": "LYMPH percent",
        "Label": "LYMPH %",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "8.0",
        "AllowedMax": "70.0",
        "Unit": "%",
        "SD": "0",
        "Mean": "39.00",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "19.2"
    },
    {
        "Item": "MONO percent",
        "Label": "MONO %",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "4.0",
        "AllowedMax": "19.0",
        "Unit": "%",
        "SD": "0",
        "Mean": "11.50",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "13.2"
    },
    {
        "Item": "EO percent",
        "Label": "EO %",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.0",
        "AllowedMax": "7.0",
        "Unit": "%",
        "SD": "0",
        "Mean": "4.00",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.1"
    },
    {
        "Item": "BASO percent",
        "Label": "BASO %",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.0",
        "Unit": "%",
        "SD": "0",
        "Mean": "0.50",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.4"
    },
    {
        "Item": "IG no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.28",
        "Unit": "x 10^9/L%",
        "SD": "0",
        "Mean": "0.14",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.07"
    },
    {
        "Item": "IG percent",
        "Label": "IG %",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.7",
        "Unit": "%",
        "SD": "0",
        "Mean": "0.85",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.6"
    },
    {
        "Item": "RET no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "29.0",
        "AllowedMax": "120.0",
        "Unit": "x 10^6/μL",
        "SD": "0",
        "Mean": "74.50",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "100"
    },
    {
        "Item": "RET percent",
        "Label": "RET %",
        "Structure -->": "",
        "Groups": "P11111",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.4",
        "AllowedMax": "4.8",
        "Unit": "%",
        "SD": "0",
        "Mean": "2.60",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.01"
    },
    {
        "Item": "P22222",
        "Label": "",
        "Structure -->": "",
        "Groups": "PASample",
        "Subgroup": "PASample",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "Err-range",
        "Analysis dates -->": "",
        "Presenting": "11/16/2023 12:50:24"
    },
    {
        "Item": "MRN",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "011-22"
    },
    {
        "Item": "First Name",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "Two"
    },
    {
        "Item": "Last Name",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "Patient"
    },
    {
        "Item": "Gender",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "F"
    },
    {
        "Item": "age",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "25"
    },
    {
        "Item": "ward",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "7"
    },
    {
        "Item": "doctor",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "PatientInfo",
        "Options -->": "",
        "Description": "M.D"
    },
    {
        "Item": "Cell Pack DCL",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "ReagentInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "Y3006"
    },
    {
        "Item": "Sulfoyser",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "ReagentInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "A2014"
    },
    {
        "Item": "Lysercell WDF",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "ReagentInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "Y2061"
    },
    {
        "Item": "Validated",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Output",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Rack no.",
        "Label": "Rack #",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1"
    },
    {
        "Item": "Position",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1"
    },
    {
        "Item": "Action",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "Error",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "RunInfo"
    },
    {
        "Item": "P / N",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "RunInfo",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "",
        "AllowedMax": "",
        "Unit": "",
        "SD": "",
        "Mean": "",
        "CV": "",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "N"
    },
    {
        "Item": "Flags",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "Other"
    },
    {
        "Item": "Graph",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "Other"
    },
    {
        "Item": "WBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "5.9",
        "AllowedMax": "16.7",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "11.30",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "6.87"
    },
    {
        "Item": "RBC",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "3.2",
        "AllowedMax": "5.1",
        "Unit": "x 10^6/μL",
        "SD": "0",
        "Mean": "4.16",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.46"
    },
    {
        "Item": "HGB",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "10.2",
        "AllowedMax": "16.6",
        "Unit": "g/dL",
        "SD": "0",
        "Mean": "13.40",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "9.5"
    },
    {
        "Item": "HCT",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.0",
        "Unit": "L/L",
        "SD": "0",
        "Mean": "0.50",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.292"
    },
    {
        "Item": "MCV",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "75.6",
        "AllowedMax": "106.3",
        "Unit": "fL",
        "SD": "0",
        "Mean": "90.95",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "78"
    },
    {
        "Item": "MCH",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "26.0",
        "AllowedMax": "36.4",
        "Unit": "pg",
        "SD": "0",
        "Mean": "31.20",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "26"
    },
    {
        "Item": "MCHC",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "33.6",
        "AllowedMax": "35.7",
        "Unit": "g/dL",
        "SD": "0",
        "Mean": "34.65",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "34"
    },
    {
        "Item": "PLT",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "95.0",
        "AllowedMax": "471.0",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "283.00",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "211"
    },
    {
        "Item": "RDW-SD",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "34.9",
        "AllowedMax": "65.7",
        "Unit": "fL",
        "SD": "0",
        "Mean": "50.30",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "46.2"
    },
    {
        "Item": "RDW-CV",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "13.3",
        "AllowedMax": "18.2",
        "Unit": "%",
        "SD": "0",
        "Mean": "15.75",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "14"
    },
    {
        "Item": "MPV",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "7.3",
        "AllowedMax": "9.9",
        "Unit": "fL",
        "SD": "0",
        "Mean": "8.60",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "8"
    },
    {
        "Item": "NEUT no.",
        "Label": "NEUT#",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "2.2",
        "AllowedMax": "11.4",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "6.80",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.33"
    },
    {
        "Item": "LYMPH no.",
        "Label": "LYMPH #",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.2",
        "AllowedMax": "5.7",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "3.45",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.32"
    },
    {
        "Item": "MONO no.",
        "Label": "MONO #",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.1",
        "AllowedMax": "5.0",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "2.55",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.91"
    },
    {
        "Item": "EO no.",
        "Label": "EO #",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.5",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "0.25",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.28"
    },
    {
        "Item": "BASO no.",
        "Label": "BASO #",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.1",
        "Unit": "x 10^3/μL",
        "SD": "0",
        "Mean": "0.05",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.03"
    },
    {
        "Item": "NEUT percent",
        "Label": "NEUT%",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "14.6",
        "AllowedMax": "69.3",
        "Unit": "%",
        "SD": "0",
        "Mean": "41.95",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "63.1"
    },
    {
        "Item": "LYMPH percent",
        "Label": "LYMPH %",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "8.0",
        "AllowedMax": "70.0",
        "Unit": "%",
        "SD": "0",
        "Mean": "39.00",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "19.2"
    },
    {
        "Item": "MONO percent",
        "Label": "MONO %",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "4.0",
        "AllowedMax": "19.0",
        "Unit": "%",
        "SD": "0",
        "Mean": "11.50",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "13.2"
    },
    {
        "Item": "EO percent",
        "Label": "EO %",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "1.0",
        "AllowedMax": "7.0",
        "Unit": "%",
        "SD": "0",
        "Mean": "4.00",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "4.1"
    },
    {
        "Item": "BASO percent",
        "Label": "BASO %",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.0",
        "Unit": "%",
        "SD": "0",
        "Mean": "0.50",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.4"
    },
    {
        "Item": "IG no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "0.28",
        "Unit": "x 10^9/L%",
        "SD": "0",
        "Mean": "0.14",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "0.07"
    },
    {
        "Item": "IG percent",
        "Label": "IG %",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.0",
        "AllowedMax": "1.7",
        "Unit": "%",
        "SD": "0",
        "Mean": "0.85",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.6"
    },
    {
        "Item": "RET no.",
        "Label": "",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "29.0",
        "AllowedMax": "120.0",
        "Unit": "x 10^6/μL",
        "SD": "0",
        "Mean": "74.50",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "100"
    },
    {
        "Item": "RET percent",
        "Label": "RET %",
        "Structure -->": "",
        "Groups": "P22222",
        "Subgroup": "HAParameter",
        "Options -->": "",
        "Description": "",
        "AllowedMin": "0.4",
        "AllowedMax": "4.8",
        "Unit": "%",
        "SD": "0",
        "Mean": "2.60",
        "CV": "0.00",
        "Status": "",
        "Analysis dates -->": "",
        "Presenting": "1.01"
    }
];
